import { useEffect, useState, FC } from 'react';
import { Formik, Form } from 'formik';
import { SelectChangeEvent, Button, Grid, Autocomplete, TextField, Select, MenuItem, InputLabel, IconButton, FormControl } from '@mui/material';
import Box from '@mui/material/Box';
import { DataField } from '../../atoms';
import * as functions from '../../shared/functions';
import { IFormField, IFormDropDown } from '../../shared/globalTypes';
import * as constants from '../../../constants/_pickerValues';
import { useDispatch, useSelector } from "react-redux";
import * as jobScheduleTrigger from '../../../store/jobSchedules/action'
import InfoIcon from '@mui/icons-material/Info';
import Back from '../../atoms/backButton'
import Skeleton from '@mui/material/Skeleton';
import Tooltip from '@mui/material/Tooltip';
import cronstrue from 'cronstrue';
import * as loaderActions from '../../../store/dataLoader/actions';
import * as loaderSelector from '../../../store/dataLoader/selectors';
import CustomizedDialogs from '../../atoms/modal/customizedDialogs';
import * as webhookAction from '../../../store/webhooks/actions'
import SaveIcon from '@mui/icons-material/Save';
import { IUser } from '../../../store/groups/types';
import * as eventTasks from '../../../store/eventBasedTrigger/actions'
import { getProfileDataSelector } from '../../../store/auth/selectors';
import { getGroupPendingSelector, getGroupUsersSelector } from '../../../store/groups/selectors';
import { fetchGroupUsersRequest } from '../../../store/groups/actions';
import { getRoleClaimsSelector } from "../../../store/auth/selectors";
import React from 'react';
import { useParams } from 'react-router';
import { deleteLoaderReq, fetchLoaderDetailsReq } from '../../../store/dataLoader/actions';
import * as eventBasedTrigger from '../../../store/events/actions'
import { getLoaderSelector, postDataSelector, getLoaderPendingSelector, putDataSelector } from "../../../store/dataLoader/selectors"
import DataProvisioningWorkflow from "../dataProvisioningWorkflow/dataProvisioningWorkflow";
import { getDataProvisioningWorkflowStateSelector } from '../../../store/dataProvisioningWorkflow/selectors'
import { fetchExtractorDetailReq } from '../../../store/extractor/actions';
import { getExtractorDetailPendingSelector, getExtractorDetailSelector } from "../../../store/extractor/selectors";
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp'
import { getPatternsSelector } from "../../../store/extractor/selectors";
import { getEventListPendingSelector, getInboundListPendingSelector, getOutboundListPendingSelector, getTaskConnectionSelector, postTaskSelector, getTaskListSelector, getLoaderListSelector } from "../../../store/eventBasedTrigger/selectors";
import { fetchPatternsReq } from '../../../store/extractor/actions';
import { IDeleteParams, LayerType } from '../../../store/extractor/types';
import { nextStep } from '../../../store/dataProvisioningWorkflow/actions';
import TriggerRow from '../../molecules/triggerRow';
import { ITaskListParams, IPostTaskParams, ILoaderListParams } from '../../../store/eventBasedTrigger/types'
import { IJobListParams } from '../../../store/timeBasedTrigger/types';
import Stack from '@mui/material/Stack';
import ActionRow from '../../molecules/actionRow';
import LoaderStatus from '../../molecules/loaderStatus/LoaderStatus';
import { LoadingButton } from '@mui/lab';
import { getTargetPendingSelector, getTargetSelector } from '../../../store/dataTarget/selectors';
import { fetchTargetDetailsReq } from '../../../store/dataTarget/actions';
import * as jobDispatch from '../../../store/timeBasedTrigger/actions';
import * as taskDispatch from '../../../store/eventBasedTrigger/actions';
import * as webhookDispatch from '../../../store/webhooks/actions';
import { deleteEventsReq } from '../../../store/events/actions';
import { deleteExtJobSchedulesReq } from '../../../store/jobSchedules/action';
import { getEventListSelector, getInboundListSelector, getOutboundListSelector } from '../../../store/eventBasedTrigger/selectors';
import { getJobListSelector } from '../../../store/timeBasedTrigger/selectors'
import { ITaskConnectionParams } from '../../../store/eventBasedTrigger/types';
import { useNavigate } from "react-router-dom";
import { convertUTCDateToLocalDate } from '../../shared/functions';
import { timeZoneValues } from '../../../constants/_pickerValues'
import format from 'date-fns/format'
import { IDP_USERS_PRODUCTION } from "../../../constants/common";
import OverRideExplorer from "../overRideExplorer/OverRideExplorer";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import AppConfig from "../../../config/AppConfig";

// Form fields object
export interface IDataLoaderFields {
    description: IFormField;
    owner: IFormField;
    dataExtractorName: IFormField;
    dataTargetName: IFormField;
    schema: IFormField;
    tableName: IFormField;
    userDefinedFilters: IFormField;
    loadingType: IFormField;
    blobContainer: IFormField,
    fieldDelimiter: IFormField,
    extension: IFormField,
    manifestFileFlag: IFormField,
    isHeader: IFormField,
    fileName: IFormField,
    folderName: IFormField,
    encoding: IFormField,
    lineSeperator: IFormField,
    quoteAll: IFormField,
    manifestUseAbsolutePath: IFormField,
    fileBatchSize: IFormField,
    iamRole: IFormField,
    fileTimezone: IFormField

}

// Instantiating Data Loader's initial state
let DataLoaderInitialState: IDataLoaderFields = {
    owner:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    description:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    dataExtractorName:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    dataTargetName:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: true, },
    iamRole:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    schema:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    tableName:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    userDefinedFilters:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    loadingType:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    blobContainer:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    isHeader:
        { fieldValue: "true", isError: false, errorMsg: "", isNumber: false, },
    fieldDelimiter:
        { fieldValue: ",", isError: false, errorMsg: "", isNumber: false, },
    extension:
        { fieldValue: "csv", isError: false, errorMsg: "", isNumber: false, },
    manifestFileFlag:
        { fieldValue: "false", isError: false, errorMsg: "", isNumber: false, },
    fileName:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    folderName:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    encoding:
        { fieldValue: "UTF-8", isError: false, errorMsg: "", isNumber: false, },
    lineSeperator:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, },
    quoteAll:
        { fieldValue: "quote_minimal", isError: false, errorMsg: "", isNumber: false, },
    manifestUseAbsolutePath:
        { fieldValue: "true", isError: false, errorMsg: "", isNumber: false, },
    fileBatchSize:
        { fieldValue: "100000", isError: false, errorMsg: "", isNumber: true, },
    fileTimezone:
        { fieldValue: "", isError: false, errorMsg: "", isNumber: false, }
}


export type userDefinedFilteringList = {
    key: number,
    field: string,
    operation: string,
    filterValue: string
}


export const userDefinedFilteringInitialState = [
    {
        key: Date.now(),
        field: '',
        operation: '',
        filterValue: ''
    }
]

// Trigger Types
export type triggerTypeList = {
    key: number,
    repeat?: string,
    timezone?: string,
    webhook?: string,
};

// Action Types
export type actionTypeList = {
    key: number,
    outboundWebhook?: string,
    headers?: string,

};


// Triggers Initial State
export const triggerListInitialState = [
    {
        key: 0
    }
]

// Actions Initial State
export const actionListInitialState = [
    {
        key: Date.now() + 1
    }
]

// mode for determining if form is for add, edit or view
interface Props {
    mode?: string;
}

export const DataLoaderForm: FC<Props> = ({ mode = constants.MODE.add }: Props) => {
    const dispatch = useDispatch();
    const [actions, setActions] = useState(actionListInitialState)
    const postDataLoader = useSelector(postDataSelector);
    const putDataLoader = useSelector(putDataSelector);
    const getTaskId = useSelector(postTaskSelector)
    const userProfile = useSelector(getProfileDataSelector);
    const idpUsersProduction = useSelector(getGroupUsersSelector(IDP_USERS_PRODUCTION));
    const idpUsersProductionPending = useSelector(getGroupPendingSelector(IDP_USERS_PRODUCTION));
    const getDataLoader = useSelector(getLoaderSelector);
    const loadingDataLoader = useSelector(getLoaderPendingSelector);
    const getDataExtractor = useSelector(getExtractorDetailSelector);
    const getExtractorPending = useSelector(getExtractorDetailPendingSelector);
    const getDataTarget = useSelector(getTargetSelector);
    const getDataTargetPending = useSelector(getTargetPendingSelector);
    const workflowState = useSelector(getDataProvisioningWorkflowStateSelector);
    const patterns = useSelector(getPatternsSelector);
    const jobs = useSelector(getJobListSelector);
    const getTaskList = useSelector(getTaskListSelector)
    const getEvents = useSelector(getEventListSelector)
    const inboundList = useSelector(getInboundListSelector);
    const outboundList = useSelector(getOutboundListSelector);
    const getTaskConnection = useSelector(getTaskConnectionSelector)
    const pending = useSelector(loaderSelector.postDataPendingSelector)
    const pendingEditedLoader = useSelector(loaderSelector.putDataPendingSelector)
    const extractorDetail = useSelector(getExtractorDetailSelector);
    const getLoaderList = useSelector(getLoaderListSelector);
    const eventsPending = useSelector(getEventListPendingSelector)
    const outboundPendingList = useSelector(getOutboundListPendingSelector);
    const inboundPendingList = useSelector(getInboundListPendingSelector);
    const [triggerList, setTriggerList] = useState<any>()
    const [inboundWebhookList, setInboundWebhookList] = useState<any>()
    const [eventList, setEventList] = useState<any>()
    const [loaderList, setLoaderList] = useState<any>()
    const [actionList, setActionList] = useState<any>()
    const [loaderEditList, setEditLoaderList] = useState<any>()
    const [ownerValue, setOwnerValue] = useState('')
    const [iamRoleValue, setIamRoleValue] = useState('')
    const [extractorColumns, setExtractorColumns] = useState<any>();
    const [layerName, setLayerName] = useState('')
    const [taskId, setTaskId] = useState<any>();
    const [taskValue, setTaskValue] = useState<any>();
    const [editTriggerList, setEditTriggerList] = useState(triggerListInitialState)
    const [editInboundWebhookList, setEditInboundWebhookList] = useState<any>()
    const [editActionList, setEditActionList] = useState<any>()
    const [eventEditList, setEditEventList] = useState<any>()
    const [isAdmin, setIsAdmin] = useState(true);
    const [taskDisabled, setTaskDisabled] = useState(false);
    const [jobList, setJobList] = useState<any>();
    const [required, setRequired] = useState(true);
    const [typeError, setTypeError] = useState(false);
    const [createdBy, setCreatedBy] = useState('');
    const [createdOn, setCreatedOn] = useState<any>();
    const [lastModified, setLastModified] = useState<any>();
    const [taskConnection, setTaskConnection] = useState<any>();
    const [lastUpdated, setLastUpdated] = useState('');
    const [tasks, setTasks] = useState<any>();
    const [loader, setLoader] = useState(false)
    const [open, setOpen] = useState(false);
    const [openTimeTrigger, setOpenTimeTrigger] = useState(false);
    const [openOutbound, setOpenOutbound] = useState(false);
    const [outbound, setOutbound] = useState<any>();
    const [inbound, setInbound] = useState<any>();
    const { batchCode } = useParams();
    const [triggers, setTriggers] = useState(triggerListInitialState);
    const [userDefinedFilters, setUserDefinedFilters] = useState<userDefinedFilteringList[]>(userDefinedFilteringInitialState);
    const [getLayerName, setGetLayerName] = useState<any>()
    const [userMail, setUserMail] = useState('')
    const navigate = useNavigate();
    const [viewTargetID, setViewTargetID] = useState<any>()
    const [loaderDescription, setLoaderDescription] = useState('');
    const [openSettings, setOpenSettings] = useState(false)
    const [loaderNavigation, setLoaderNavigation] = useState(false)
    const [loaderChanges, setLoaderChanges] = useState(false)
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)
    const [displaySaveBtn, setDisplaySaveBtn] = useState(false)
    const [newExtTrigger, setNewExtTrigger] = useState<any>();

    const defaultTimezone = `${format(new Date(), 'xxx')} UTC`

    const loaderParams: ILoaderListParams = {
        taskType: "Loader_Task"
    };

    // roles  - IDP.Admin or IDP.User
    const roles: string[] = useSelector(getRoleClaimsSelector);

    useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin"));
        }
    }, [roles])

    useEffect(() => {
        if (!pending && !pendingEditedLoader && loader) {
            setDisplaySaveBtn(true);
        }
        else {
            setDisplaySaveBtn(false);
        }
    }, [pendingEditedLoader, pending])

    useEffect(() => {
        if (!loaderChanges) return;
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (mode !== constants.MODE.view && loaderChanges) {
                e.preventDefault();
                e.returnValue = "";
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [loaderChanges, mode]);


    // Populate owner
    useEffect(() => {
        window.scrollTo(0, 0)
        if (!idpUsersProductionPending && idpUsersProduction.length <= 0) {
            dispatch(fetchGroupUsersRequest(IDP_USERS_PRODUCTION));
        }
        resetFields()

        if (workflowState.isActive && workflowState.selectedDataTarget?.targetId !== undefined && workflowState.selectedDataTarget?.targetId !== null && mode === constants.MODE.add) {
            setGetLayerName(workflowState.selectedDataTarget.name)
            dispatch(fetchPatternsReq({ layerType: LayerType.PROV, sourceId: workflowState.selectedDataTarget.targetId }))
        }

    }, []);

    const [dataLoaderFormData, setDataLoaderFormData] = useState(DataLoaderInitialState);

    // reset fields
    const resetFields = () => {
        dataLoaderFormData.userDefinedFilters.fieldValue = ""
        dataLoaderFormData.blobContainer.fieldValue = ""
        dataLoaderFormData.fieldDelimiter.fieldValue = ","
        dataLoaderFormData.extension.fieldValue = "csv"
        dataLoaderFormData.manifestFileFlag.fieldValue = "false"
        dataLoaderFormData.isHeader.fieldValue = "true"
        dataLoaderFormData.fileName.fieldValue = ""
        dataLoaderFormData.folderName.fieldValue = ""
        dataLoaderFormData.encoding.fieldValue = "UTF-8"
        dataLoaderFormData.iamRole.fieldValue = ""
        dataLoaderFormData.quoteAll.fieldValue = "quote_minimal"
        dataLoaderFormData.manifestUseAbsolutePath.fieldValue = "true"
        dataLoaderFormData.fileTimezone.fieldValue = defaultTimezone

        setDataLoaderFormData(dataLoaderFormData);
    };

    // GET Loader details, depending on loader batch code (when it is either VIEW or EDIT)
    useEffect(() => {
        // When batch code is available, when it is either VIEW or EDIT
        if (mode !== constants.MODE.add && batchCode) {
            dispatch(fetchLoaderDetailsReq(batchCode));
        }

    }, [batchCode]);

    // Handling owner changes
    useEffect(() => {
        dataLoaderFormData.owner.fieldValue = ownerValue
        setDataLoaderFormData(dataLoaderFormData)
    }, [ownerValue])

    // Handling iamRole changes
    useEffect(() => {
        dataLoaderFormData.iamRole.fieldValue = iamRoleValue
        setDataLoaderFormData(dataLoaderFormData)
    }, [iamRoleValue])

    useEffect(() => {
        if (workflowState.isActive && workflowState.selectedDataSet)
            dispatch(fetchExtractorDetailReq(workflowState.selectedDataSet.batchCode))
    }, []);


    // If mode is edit or view fetch loading type
    useEffect(() => {
        if (mode !== constants.MODE.add) {
            let selectedPattern = patterns && patterns.PROV?.find(pattern => pattern.etlPatternId === getDataLoader?.technicalMetadata.provPattern.selectedPatternId)
            if (selectedPattern?.patternName.includes("Delta")) {
                dataLoaderFormData.loadingType.fieldValue = 'delta'
            } else {
                dataLoaderFormData.loadingType.fieldValue = 'rebase'
            }
            setDataLoaderFormData(dataLoaderFormData)
        }

    }, [patterns])


    useEffect(() => {
        setExtractorColumns(extractorDetail?.columnGovernanceMetadata.map((item: any, index: number) => {
            return item.columnId
        }))
    }, [extractorDetail])


    //setting owner and user email value
    useEffect(() => {
        if (userProfile) {
            setOwnerValue(userProfile['userPrincipalName'])
            setUserMail(userProfile?.mail)
            // resetting redux for loaders to avoid any old batch codes on page load
            dispatch(loaderActions.postDataLoaderReset())
            dispatch(loaderActions.putDataLoaderReset())

        }
    }, [userProfile])

    // fetching patterns on edit or view mode
    useEffect(() => {
        if (getDataLoader && getDataLoader?.technicalMetadata?.targetLayerId && mode !== constants.MODE.add) {
            dispatch(fetchPatternsReq({ layerType: LayerType.PROV, sourceId: getDataLoader?.technicalMetadata?.targetLayerId }))
        }
    }, [getDataLoader])

    // fetching target name on edit
    useEffect(() => {
        if (getDataTarget && mode !== constants.MODE.add) {
            dataLoaderFormData.dataTargetName.fieldValue = getDataTarget ? getDataTarget?.name : 'Not Available'
        }
    }, [getDataTarget])

    // Update dataLoaderFormData state on Edit and View
    useEffect(() => {
        if ((mode === constants.MODE.edit || mode === constants.MODE.view) && getDataLoader) {
            dispatch(fetchExtractorDetailReq(getDataLoader?.technicalMetadata?.extractorBatchCode))
            dispatch(fetchTargetDetailsReq(getDataLoader?.technicalMetadata?.targetLayerId))

            const params: IJobListParams = {
                taskCode: batchCode ? batchCode : "",
            }
            dispatch(jobDispatch.fetchJobListReq(params));
            if (tasks && tasks.length > 0) {
                const eventListParams = {
                    eventActionValue: tasks[0].id
                };
                dispatch(taskDispatch.fetchEventListReq(eventListParams))
            }
            setViewTargetID(getDataLoader?.technicalMetadata?.targetLayerId)

            dataLoaderFormData.owner.fieldValue = getDataLoader?.businessMetadata?.owner ?? 'None';
            dataLoaderFormData.description.fieldValue = getDataLoader?.businessMetadata?.description ?? 'None';
            dataLoaderFormData.dataExtractorName.fieldValue = getDataLoader?.technicalMetadata?.extractorBatchCode;
            dataLoaderFormData.dataTargetName.fieldValue = String(getDataLoader?.technicalMetadata?.targetLayerId);
            dataLoaderFormData.schema.fieldValue = getDataLoader?.technicalMetadata?.schema;
            dataLoaderFormData.tableName.fieldValue = getDataLoader?.technicalMetadata?.tableName;
            dataLoaderFormData.userDefinedFilters.fieldValue = getDataLoader?.technicalMetadata?.userDefinedFilters;
            dataLoaderFormData.blobContainer.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.blobContainer ?? "";
            dataLoaderFormData.fieldDelimiter.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.fieldDelimiter ?? ",";
            dataLoaderFormData.extension.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.extension ?? "csv";
            dataLoaderFormData.manifestFileFlag.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.manifestFileFlag ?? "false";
            dataLoaderFormData.fileName.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.fileName ?? getDataLoader?.technicalMetadata?.tableName;
            dataLoaderFormData.folderName.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.folderName ?? getDataLoader?.technicalMetadata?.schema;
            dataLoaderFormData.encoding.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.encoding ?? "UTF-8";
            dataLoaderFormData.lineSeperator.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.lineSeperator ?? "";
            dataLoaderFormData.quoteAll.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.quoteAll ?? "quote_minimal";
            dataLoaderFormData.isHeader.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.isHeader ?? "true";
            dataLoaderFormData.manifestUseAbsolutePath.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.manifestUseAbsolutePath ?? "true";
            dataLoaderFormData.fileBatchSize.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.fileBatchSize?.toString() ?? "100000";
            dataLoaderFormData.iamRole.fieldValue = (tasks && tasks.length > 0) ? tasks[0].role : '';
            dataLoaderFormData.fileTimezone.fieldValue = getDataLoader?.technicalMetadata?.fileRegistration?.fileTimezone ? getDataLoader?.technicalMetadata?.fileRegistration?.fileTimezone + " UTC" : defaultTimezone;
            setLastUpdated(getDataLoader?.businessMetadata?.updatedBy)
            setCreatedOn(convertUTCDateToLocalDate(getDataLoader?.businessMetadata?.createdOn).toString())
            setLastModified(convertUTCDateToLocalDate(getDataLoader?.businessMetadata?.updatedOn).toString())
            setCreatedBy(getDataLoader?.businessMetadata?.createdBy)
            const splitword = getDataLoader?.technicalMetadata?.userDefinedFilters.split('AND');
            const objFilters: userDefinedFilteringList[] = []

            splitword.map((singleFilter) => {
                const splitstring = singleFilter.split(' ');
                const objValue = splitstring.filter((e) => { return e.trim() });
                const obj: any = {}
                objValue.forEach((elem: string, i: number) => {
                    switch (i) {
                        case 0: obj["field"] = elem
                            break;
                        case 1: obj["operation"] = elem
                            break;
                        case 2:
                            if (elem.indexOf('\'') > -1) {
                                elem = elem.replace(/['"]+/g, '');
                                obj["filterValue"] = elem
                            }
                            else {
                                obj["filterValue"] = elem
                            }
                            break;
                        default:
                    }
                })
                obj["key"] = Math.random();
                objFilters.push(obj)
            })

            setUserDefinedFilters(objFilters)
            setDataLoaderFormData(dataLoaderFormData);

            if (mode === constants.MODE.view && dataLoaderFormData.owner.fieldValue.toLowerCase() === userProfile?.mail.toLowerCase()) {
                setDisplaySaveBtn(true)
            }
            else {
                setDisplaySaveBtn(false)
            }

        } else if (mode === constants.MODE.add) {
            dataLoaderFormData.owner.fieldValue = '';
            dataLoaderFormData.description.fieldValue = workflowState.selectedDataSet ? workflowState.selectedDataSet.description : 'NA';
            dataLoaderFormData.dataExtractorName.fieldValue = workflowState.selectedDataSet ? workflowState.selectedDataSet.tableId : 'NA';
            dataLoaderFormData.dataTargetName.fieldValue = workflowState.selectedDataTarget?.name ? workflowState.selectedDataTarget.name : 'NA';
            dataLoaderFormData.schema.fieldValue = workflowState.selectedDataSet ? workflowState.selectedDataSet.schema : "NA";
            dataLoaderFormData.tableName.fieldValue = workflowState.selectedDataSet ? workflowState.selectedDataSet.table : "NA";
            dataLoaderFormData.userDefinedFilters.fieldValue = '';
            dataLoaderFormData.loadingType.fieldValue = 'delta';

            if (workflowState.selectedDataTarget?.layerType === "LOAD_ADLS" || workflowState.selectedDataTarget?.layerType === "LOAD_S3") {
                dataLoaderFormData.folderName.fieldValue = workflowState.selectedDataSet ? workflowState.selectedDataSet.schema : "NA";
                dataLoaderFormData.fileName.fieldValue = workflowState.selectedDataSet ? workflowState.selectedDataSet.table : "NA";
            }
            setDataLoaderFormData(dataLoaderFormData);

        }

    }, [getDataLoader, mode]);


    //************************* fetching job and extractor event for triggers ******************
    useEffect(() => {
        if (mode === constants.MODE.view || mode === constants.MODE.edit) {
            // fetch jobs
            const params: IJobListParams = {
                taskCode: batchCode ? batchCode : ''
            };

            const loaderParams: ILoaderListParams = {
                taskType: "Loader_Task"
            };

            dispatch(jobDispatch.fetchJobListReq(params));
            dispatch(taskDispatch.fetchTaskListReq(loaderParams));
        }
    }, []);


    // Step 1: fetch task connection
    useEffect(() => {
        if (getLayerName !== undefined) {
            const layerNameParams: ITaskConnectionParams = { layerName: getLayerName }
            dispatch(eventTasks.fetchTaskConnectionReq(layerNameParams));
        }

    }, [getLayerName]);

    useEffect(() => {
        setTaskConnection(getTaskConnection)
    }, [getTaskConnection]);

    useEffect(() => {
        const params: ITaskListParams = {
            taskType: "Loader_Task",
            taskCode: encodeURIComponent(batchCode ?? '')
        };
        dispatch(eventTasks.fetchTaskListReq(params));
    }, [batchCode]);

    useEffect(() => {
        if (mode === constants.MODE.edit) {
            setTaskId(getLoaderList)
        }
    }, [getLoaderList]);

    useEffect(() => {
        if (mode === constants.MODE.view || mode === constants.MODE.edit) {
            setTasks(getTaskList)
        }
    }, [getTaskList]);

    // Step 2: Check if there's an existing task connection, if yes then create new task without a connection
    useEffect(() => {
        if (mode === constants.MODE.edit) {
            if (taskConnection && taskConnection.length > 0) {
                // Then, check if there is an existing task connection.
                let newBatchCode = encodeURIComponent(encodeURIComponent(batchCode ?? ''));
                const singleTaskID = taskId && taskId.length > 0 && taskId.filter((item: any, index: any) => {
                    return item.taskCode === newBatchCode
                })
                setTasks(singleTaskID);
                if (singleTaskID && singleTaskID.length === 0) {
                    const taskParams: IPostTaskParams = {
                        layerName: getLayerName,
                        extractTaskId: null,
                        taskCode: newBatchCode,
                        taskType: "Loader_Task",
                        owner: dataLoaderFormData.owner.fieldValue,
                        role: dataLoaderFormData.iamRole.fieldValue,
                        enabled: true,
                        description: loaderDescription
                    };
                    dispatch(eventTasks.postTaskRequest(taskParams));
                }
            }
        }
    }, [getLayerName, taskConnection, taskId]);



    // Step 3: Check if there is an existing task. If so, then do nothing. If not and task ID is null then create a new task with a new connection
    useEffect(() => {
        if (mode === constants.MODE.edit) {
            if (taskId === null) {
                if (taskConnection && taskConnection.length === 0) {
                    const taskParams: IPostTaskParams = {
                        newTaskConnection: {
                            layerName: getLayerName,
                            description: "Creating a new task connection",
                            criticality: 0
                        },
                        extractTaskId: null,
                        taskCode: encodeURIComponent(encodeURIComponent(batchCode ?? '')),
                        taskType: "Loader_Task",
                        owner: dataLoaderFormData.owner.fieldValue,
                        role: dataLoaderFormData.iamRole.fieldValue,
                        enabled: true,
                        description: loaderDescription
                    };
                    dispatch(eventTasks.postTaskRequest(taskParams));
                }
            }


        }
    }, [getLayerName, taskId, taskConnection]);


    // Step 4: Fetch existing triggers and actions and display them on view and exist
    useEffect(() => {
        if (mode === constants.MODE.view || mode === constants.MODE.edit) {
            if (tasks && tasks.length > 0) {
                if (tasks[0].enabled === null && tasks[0].taskId === null) {
                    setTaskDisabled(true);
                } else {
                    setTaskDisabled(tasks[0].enabled);
                }
                setIamRoleValue(tasks[0].role)

                const eventListParams = {
                    eventActionValue: tasks[0].id,
                };

                dispatch(taskDispatch.fetchEventListReq(eventListParams));

                const inboundWebhookParams = {
                    eventType: 'WEB_HOOK.INBOUND',
                    eventActionValue: tasks && tasks.length > 0 && tasks[0].id
                };

                const outboundWebhookParams = {
                    eventAction: 'CALL_WEB_HOOK',
                    eventQualifier: tasks && tasks.length > 0 && tasks[0].id

                };

                dispatch(taskDispatch.fetchInboundListReq(inboundWebhookParams));
                dispatch(taskDispatch.fetchOutboundListReq(outboundWebhookParams));
            }
        }
    }, [tasks]);

    useEffect(() => {
        setJobList(jobs);
    }, [jobs]);

    useEffect(() => {
        setInbound(inboundList);
    }, [inboundList]);

    useEffect(() => {
        setOutbound(outboundList);
    }, [outboundList]);

    useEffect(() => {
        setEventList(getEvents);
    }, [getEvents]);

    useEffect(() => {
        if (mode !== constants.MODE.add) {
            setGetLayerName(getDataTarget?.name)
        }
    }, [getDataTarget]);



    // Set default value for owner field
    useEffect(() => {
        if (userProfile) {
            setDataLoaderFormData({ ...dataLoaderFormData, owner: functions.getFormField(userProfile['userPrincipalName']) });
        }
    }, [userProfile]);


    // Hide/display buttons if there is a data loader in the store, or if mode has changed
    useEffect(() => {
        dispatch(taskDispatch.fetchLoaderListReq(loaderParams));
    }, [postDataLoader]);

    const onDropdownChange = (e: SelectChangeEvent<string>) => {
        setDataLoaderFormData({ ...dataLoaderFormData, [e.target.name]: functions.getFormField(e.target.value) });
        setLoaderChanges(true)
    };

    // Update fieldValue when it is changed; needed to update the UI of the text fields, text areas
    // Clean value if the field changed is data loader

    const handleChange = (event: {}) => {
        const e = event as React.ChangeEvent<HTMLInputElement>;
        setDataLoaderFormData({ ...dataLoaderFormData, [e.target.name]: (e.target.name === 'name') ? functions.getFormField(functions.cleanName(e.currentTarget.value, "_")) : functions.getFormField(e.currentTarget.value) });
        setLoaderChanges(true)
    }

    // onchange for trigger
    const onTriggerChange = (inputTrigger: triggerTypeList) => {
        const newTriggers = triggers.map((item) => {
            if (item.key === inputTrigger.key) return inputTrigger;
            return item;
        })
        setTriggers(newTriggers)
        setLoaderChanges(true)
    }

    /****************** CREATE LOADER, EXECUTE TRIGGERS **************************/

    // Step 1: Check if there's an existing task connection, if yes then create new task without a connection

    useEffect(() => {
        if (postDataLoader && mode === constants.MODE.add) {
            const batchCodeValue = postDataLoader.batchCode.toString()
            const params: ITaskListParams = {
                taskType: "Loader_Task",
                taskCode: batchCodeValue
            };
            dispatch(eventTasks.fetchTaskListReq(params));
        }
    }, [postDataLoader]);



    useEffect(() => {
        if (postDataLoader && mode === constants.MODE.add) {
            const batchCodeValue = postDataLoader.batchCode.toString()
            //check if there is existing task connection
            if (taskConnection && taskConnection.length > 0) {
                // Then, check if there is an existing task ID, if not create a new task ID
                const singleTaskID = taskId && taskId.length > 0 && taskId.filter((item: any, index: any) => {
                    return item.taskCode === batchCodeValue
                })
                if (singleTaskID && singleTaskID.length === 0) {
                    const taskParams: IPostTaskParams = {
                        layerName: getLayerName,
                        extractTaskId: null,
                        taskCode: batchCodeValue,
                        taskType: "Loader_Task",
                        role: dataLoaderFormData.iamRole.fieldValue,
                        owner: dataLoaderFormData.owner.fieldValue,
                        enabled: true,
                        description: loaderDescription
                    };
                    dispatch(eventTasks.postTaskRequest(taskParams));
                }
            }
            else {
                // Create a new task with a new connection
                const taskParams: IPostTaskParams = {
                    newTaskConnection: {
                        layerName: getLayerName,
                        description: "Creating a new task connection",
                        criticality: 0
                    },
                    extractTaskId: null,
                    taskCode: batchCodeValue,
                    taskType: "Loader_Task",
                    owner: dataLoaderFormData.owner.fieldValue,
                    role: dataLoaderFormData.iamRole.fieldValue,
                    enabled: true,
                    description: loaderDescription
                };
                dispatch(eventTasks.postTaskRequest(taskParams));
            }
        }
    }, [postDataLoader, getLayerName, taskConnection]);

    useEffect(() => {
        setTaskValue(getTaskId)
    }, [getTaskId]);

    useEffect(() => {
        if (postDataLoader && mode === constants.MODE.add) {
            const batchCodeValue = postDataLoader.batchCode.toString()
            if (triggerList && triggerList.length > 0) {
                const timeBased = triggerList.map((item: any, index: number) => {
                    return {
                        timezone: item.timezone ? item.timezone.replace(" UTC", "") : `${format(new Date(), 'xxx')}`,
                        cronExpression: item.cronExpression,
                        criticality: 0,
                        connectionDescription: "",
                        enabled: true,
                        endpoint: "",
                        extractTaskId: null,
                        owner: dataLoaderFormData.owner.fieldValue,
                        sourceTargetName: layerName,
                        scheduleDescription: null,
                        taskCode: batchCodeValue,
                        layerName: layerName,
                        taskType: "Loader_Task",
                        taskDescription: loaderDescription
                    };
                });

                timeBased.map((item: any, index: number) => {
                    return dispatch(jobScheduleTrigger.postExtJobSchedulesRequest(item));
                })
            }
        }
    }, [postDataLoader]);


    useEffect(() => {
        if (postDataLoader && mode === constants.MODE.add) {

            if (taskValue !== null) {
                // get triggers that are time based
                // get triggers that are extractors
                if (eventList && eventList.length > 0) {
                    const extractors = eventList.map((ext: any) => {
                        return (
                            ext.extractor[0]
                        )
                    })
                    const eventBased = extractors.map((item: any, index: number) => {
                        return {
                            ...item,
                            eventType: "LOAD_TASK.SUCCESS",
                            eventAction: "TRIGGER_TASK",
                            scopeType: "LOAD_TASK",
                            eventActionValue: taskValue ? taskValue.taskId : '',
                            eventQualifier: item.newExtractorId ? item.newExtractorId : '', // Note: Set the selected extractor id value here,,
                            enabled: true,
                            description: item.description
                        };
                    });
                    eventBased.map((item: any, index: number) => {
                        return dispatch(eventBasedTrigger.postEventTriggersRequest(item));;
                    })
                }

                // get triggers that are loaders
                if (loaderList && loaderList.length > 0) {
                    const loaders = loaderList.map((itm: any) => {
                        return (
                            itm.loader[0]
                        )
                    })
                    const loaderBased = loaders.map((item: any, index: number) => {
                        return {
                            ...item,
                            eventType: "LOAD_TASK.SUCCESS",
                            eventAction: "TRIGGER_TASK",
                            scopeType: "LOAD_TASK",
                            eventActionValue: taskValue ? taskValue.taskId : '',
                            eventQualifier: item.newLoaderId ? item.newLoaderId : '', // Note: Set the selected extractor id value here,,
                            enabled: true,
                            description: item.description
                        };
                    });
                    loaderBased.map((item: any, index: number) => {
                        return dispatch(eventBasedTrigger.postEventTriggersRequest(item));
                    })
                }

                // get triggers that are inbound webhook based
                // Creating the loader for the first time, so create a new task with new task connection
                if (inboundWebhookList && inboundWebhookList.length > 0) {
                    const inboundBased = inboundWebhookList.map((item: any, index: number) => {
                        return {
                            ...item,
                            eventType: "WEB_HOOK.INBOUND",
                            eventAction: "TRIGGER_TASK",
                            scopeType: "LOAD_TASK",
                            eventActionValue: taskValue ? taskValue.taskId : '',
                            enabled: true,
                            description: item.webhook
                        };
                    });

                    inboundBased.map((item: any, index: number) => {
                        return dispatch(webhookAction.postInboundWebhookRequest(item));
                    })
                }

                // get outbound webhook actions
                if (actionList && actionList.length > 0) {

                    const actionBased = actionList.map((item: any, index: number) => {
                        return {
                            ...item,
                            eventType: "LOAD_TASK.SUCCESS",
                            eventAction: "CALL_WEB_HOOK",
                            scopeType: "LOAD_TASK",
                            eventActionValue: item.outboundWebhook,
                            eventQualifier: taskValue ? taskValue.taskId : '',
                            enabled: true,
                            description: item.description ? item.description : '',
                            header: item.header ? item.header : ''
                        };
                    });
                    actionBased.map((item: any, index: number) => {
                        return dispatch(webhookAction.postOutboundWebhookRequest(item));;
                    })
                }

            }
        }
    }, [postDataLoader, taskValue, taskId]);

    useEffect(() => {
        if (postDataLoader && mode === constants.MODE.add) {
            const batchCodeValue = postDataLoader.batchCode.toString()
            if (batchCodeValue) {
                dispatch(nextStep())
            }
        }
    }, [postDataLoader]);

    useEffect(() => {
        if (mode === constants.MODE.add) {
            setTaskId(getLoaderList)
        }
    }, [getLoaderList]);

    // ********** EDIT LOADERS SCREEN -> EDIT TRIGGERS ************

    useEffect(() => {
        if (putDataLoader && mode === constants.MODE.edit) {

            //edit the existing task
            if (typeof tasks != undefined && tasks && tasks[0]?.id != undefined) {
                dispatch(taskDispatch.putTaskRequest(tasks[0].id,
                    {
                        "owner": dataLoaderFormData.owner.fieldValue,
                        "role": getDataTarget?.layerType === "LOAD_REDSHIFT" ? dataLoaderFormData.iamRole.fieldValue : ""
                    }))
            }

            // get triggers that are existing time based jobs
            if (editTriggerList && editTriggerList.length > 0) {
                const timeBased = editTriggerList.map((item: any, index: number) => {
                    return {
                        timezone: item.timezone ? item.timezone.replace(" UTC", "") : `${format(new Date(), 'xxx')}`,
                        cronExpression: item.cronExpression,
                        enabled: true,
                        owner: dataLoaderFormData.owner.fieldValue,
                        description: item.id,
                        updatedBy: dataLoaderFormData.owner.fieldValue
                    };
                });

                timeBased.map((item: any, index: number) => {
                    return item.cronExpression ? dispatch(jobScheduleTrigger.putExtJobSchedulesRequest(item.description, item)) : ''
                })
            }

            // get triggers that are new time based jobs
            if (triggerList && triggerList.length > 0) {
                const timeBased = triggerList.map((item: any, index: number) => {

                    const isExists = jobList && jobList.length > 0 && jobList.find((job: any) => job.cronExpression === item.cronExpression && job.timezone === item.timezone)
                    if (!isExists) {
                        return {
                            timezone: item.timezone ? item.timezone.replace(" UTC", "") : `${format(new Date(), 'xxx')}`,
                            cronExpression: item.cronExpression,
                            criticality: 0,
                            connectionDescription: "",
                            enabled: true,
                            endpoint: "",
                            extractTaskId: null,
                            owner: dataLoaderFormData.owner.fieldValue,
                            sourceTargetName: layerName,
                            scheduleDescription: null,
                            taskCode: batchCode,
                            layerName: layerName,
                            taskType: "Loader_Task",
                            taskDescription: loaderDescription
                        };
                    }
                });

                timeBased.map((item: any, index: number) => {
                    return dispatch(jobScheduleTrigger.postExtJobSchedulesRequest(item));
                })
            }

            // get triggers that are new extractor jobs
            if (newExtTrigger && newExtTrigger.length > 0) {
                const extractors = newExtTrigger.map((ext: any) => {
                    return (
                        { description: ext ? ext.extractor[0].description : '', oldId: ext.id, newExtractorId: ext.extractor[0].newExtractorId }
                    )
                })
                const eventBased = extractors.map((item: any) => {
                    return {
                        ...item,
                        eventType: "LOAD_TASK.SUCCESS",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "EXTRACT_TASK",
                        eventActionValue: tasks && tasks[0].id, // Note: Get Task ID here
                        eventQualifier: item.newExtractorId ? item.newExtractorId : '', // Note: Set the selected extractor id value here,, 
                        enabled: true,
                        description: item.description
                    };
                });
                eventBased.map((item: any) => {
                    return dispatch(eventBasedTrigger.postEventTriggersRequest(item));;
                })
            }

            // get triggers that are existing extractor based jobs
            if (eventEditList && eventEditList.length > 0) {
                const extractors = eventEditList.map((ext: any) => {
                    return (
                        { description: ext.extractor[0].description, oldId: ext.id, newExtractorId: ext.extractor[0].newExtractorId }
                    )
                })
                const eventBased = extractors.map((item: any) => {
                    return {
                        ...item,
                        eventType: "LOAD_TASK.SUCCESS",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "EXTRACT_TASK",
                        eventActionValue: tasks && tasks[0].id, // Note: Get Task ID here
                        enabled: true,
                        description: item.description,
                        eventId: item.oldId ? item.oldId : '', // Note: Set existing extractor ID here
                        eventQualifier: item.newExtractorId ? item.newExtractorId : '', // Note: Set the selected extractor id value here
                    };
                });
                eventBased.map((item: any) => {
                    return dispatch(eventBasedTrigger.putEventsRequest(item.eventId, item)); // pass the existing extractor ID here
                })
            }

            // get triggers that are new loader jobs
            if (loaderList && loaderList.length > 0) {
                const loaders = loaderList.map((loader: any) => {
                    return (
                        { description: loader.loader[0].description, oldId: loader.id, newLoaderId: loader.loader[0].newLoaderId }
                    )
                })
                const loaderBased = loaders.map((item: any) => {
                    return {
                        eventType: "LOAD_TASK.SUCCESS",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: tasks && tasks[0].id,
                        eventQualifier: item.newLoaderId ? item.newLoaderId : '', // Note: Set the selected extractor id value here
                        enabled: true,
                        description: item.description ? item.description : ''
                    };
                });
                loaderBased.map((item: any) => {
                    return dispatch(eventBasedTrigger.postEventTriggersRequest(item));;
                })
            }

            // get triggers that are existing loader based jobs
            if (loaderEditList && loaderEditList.length > 0) {
                const loaders = loaderEditList.map((itm: any) => {
                    return (
                        { description: itm.loader[0].description, oldId: itm.id, newLoaderId: itm.loader[0].newLoaderId }
                    )
                })
                const loaderBased = loaders.map((item: any) => {
                    return {
                        eventType: "LOAD_TASK.SUCCESS",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: tasks && tasks[0].id,
                        eventId: item.oldId ? item.oldId : '', // Note: Set existing extractor ID here
                        eventQualifier: item.newLoaderId ? item.newLoaderId : '', // Note: Set the selected extractor id value here
                        enabled: true,
                        description: item.description ? item.description : ''
                    };
                });
                loaderBased.map((item: any) => {
                    return dispatch(eventBasedTrigger.putEventsRequest(item.eventId, item)); // pass the existing extractor ID here
                })
            }

            // get triggers that are inbound webhook based
            // Creating the loader for the first time, so create a new task with new task connection
            if (inboundWebhookList && inboundWebhookList.length > 0) {
                const inboundBased = inboundWebhookList.map((item: any, index: number) => {
                    return {
                        ...item,
                        eventType: "WEB_HOOK.INBOUND",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: tasks && tasks[0].id,
                        enabled: true,
                        description: item.webhook
                    };
                });

                inboundBased.map((item: any, index: number) => {
                    return dispatch(webhookAction.postInboundWebhookRequest(item));
                })
            }

            // get triggers that are existing inbound webhook based
            if (editInboundWebhookList && editInboundWebhookList.length > 0) {
                const inboundBased = editInboundWebhookList.map((item: any, index: number) => {
                    return {
                        eventType: "WEB_HOOK.INBOUND",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: item.eventActionValue,
                        enabled: true,
                        description: item.webhook,
                        id: item.id
                    };
                });

                inboundBased.map((item: any, index: number) => {
                    return dispatch(webhookAction.putInboundWebhookRequest(item.id, item));
                })
            }

            // get outbound webhook actions
            if (actionList && actionList.length > 0) {

                const actionBased = actionList.map((item: any, index: number) => {
                    return {
                        ...item,
                        eventType: "LOAD_TASK.SUCCESS",
                        eventAction: "CALL_WEB_HOOK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: item.outboundWebhook,
                        eventQualifier: tasks && tasks.length > 0 ? tasks[0].id : '',
                        enabled: true,
                        description: item.description ? item.description : '',
                        header: item.header ? item.header : ''
                    };
                });
                actionBased.map((item: any, index: number) => {
                    return dispatch(webhookAction.postOutboundWebhookRequest(item));;
                })
            }

            // get outbound webhook actions
            if (editActionList && editActionList.length > 0) {

                const actionBased = editActionList.map((item: any, index: number) => {
                    return {
                        eventType: "LOAD_TASK.SUCCESS",
                        eventAction: "CALL_WEB_HOOK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: item.outboundWebhook,
                        eventQualifier: item.eventQualifier,
                        enabled: true,
                        header: item.header,
                        description: item.description ? item.description : '',
                        id: item.id
                    };
                });
                actionBased.map((item: any, index: number) => {
                    return dispatch(webhookAction.putOutboundWebhookRequest(item.id, item));;
                })
            }
        }
    }, [putDataLoader]);

    // Create or update a new data loader
    // Called when the Save button is clicked

    function createNewDataLoader() {
        let filters = ''
        if (userDefinedFilters[0]?.field !== '' && userDefinedFilters[0]?.field !== undefined) {
            for (var i = 0; i < userDefinedFilters.length; i++) {
                if (i > 0) {
                    filters += 'AND '
                }
                filters += userDefinedFilters[i].field + " "
                filters += userDefinedFilters[i].operation + " "
                if (mode === constants.MODE.add) {
                    filters += isNaN(parseFloat(userDefinedFilters[i].filterValue)) && (userDefinedFilters[i].filterValue !== undefined
                        ? userDefinedFilters[i].filterValue.indexOf('\'') < 0 : false) ? "'" + userDefinedFilters[i].filterValue + "'" + " " : userDefinedFilters[i].filterValue + " ";
                }
                else {
                    filters += isNaN(parseFloat(userDefinedFilters[i].filterValue)) && (userDefinedFilters[i].filterValue !== undefined
                        ? userDefinedFilters[i].filterValue.indexOf('\'') < 0 : false) ? "''" + userDefinedFilters[i].filterValue + "''" + " " : userDefinedFilters[i].filterValue + " ";
                }

            }
        }

        let pattern = ''
        if (patterns) {
            if (workflowState.selectedDataTarget?.layerType === "LOAD_S3") {
                pattern = patterns.PROV.find(x => x.patternName === "RIO-PROV ADB Synapse to S3")!.etlPatternId;
            }
            else {
                for (var i = 0; i < patterns.PROV.length; i++) {
                    // check if it's mssql and only display v1 pattern if it's delta
                    if (workflowState.selectedDataTarget?.layerType === "LOAD_MSSQL") {

                        if (patterns.PROV[i].patternName.includes("Delta v1")) {

                            if (dataLoaderFormData.loadingType.fieldValue === 'delta') {
                                pattern = patterns.PROV[i].etlPatternId
                                break;
                            }
                        } else {
                            pattern = patterns.PROV[i].etlPatternId
                        }
                    }
                    else {

                        if (patterns.PROV[i].patternName.includes("Delta")) {

                            if (dataLoaderFormData.loadingType.fieldValue === 'delta') {
                                pattern = patterns.PROV[i].etlPatternId
                                break;
                            }
                        } else {
                            pattern = patterns.PROV[i].etlPatternId
                        }
                    }

                }
            }
        }

        // Setup payload for POST data Loader endpoint
        if (mode === constants.MODE.add) {

            //first check if amazon s3 form fields are empty
            if (workflowState.selectedDataTarget?.layerType === "LOAD_ADLS" || workflowState.selectedDataTarget?.layerType === "LOAD_S3") {
                if (!dataLoaderFormData.blobContainer.fieldValue ||
                    !dataLoaderFormData.fieldDelimiter.fieldValue ||
                    !dataLoaderFormData.extension.fieldValue ||
                    !dataLoaderFormData.isHeader.fieldValue ||
                    !dataLoaderFormData.manifestFileFlag.fieldValue ||
                    !dataLoaderFormData.fileName.fieldValue ||
                    !dataLoaderFormData.folderName.fieldValue ||
                    !dataLoaderFormData.encoding.fieldValue ||
                    !dataLoaderFormData.quoteAll.fieldValue ||
                    !dataLoaderFormData.manifestUseAbsolutePath.fieldValue ||
                    !dataLoaderFormData.fileBatchSize.fieldValue
                )
                    return alert("Please make sure to fill all required fields")
            }

            if (workflowState.selectedDataTarget?.layerType === "LOAD_REDSHIFT") {
                if (!dataLoaderFormData.iamRole.fieldValue)
                    return alert("Please make sure to fill the IAM Role")
            }

            // validation if field is empty
            if (dataLoaderFormData.description.fieldValue === "") {
                alert("Loader name cannot be empty")
            }
            else {

                if (workflowState.selectedDataTarget?.layerType === "LOAD_ADLS" || workflowState.selectedDataTarget?.layerType === "LOAD_S3") {
                    setLoaderDescription(dataLoaderFormData.description.fieldValue)

                    let postPayload = {
                        "businessMetadata": {
                            "owner": dataLoaderFormData.owner.fieldValue,
                            "description": dataLoaderFormData.description.fieldValue
                        },
                        "technicalMetadata": {
                            "extractorBatchCode": workflowState.selectedDataSet.batchCode ? workflowState.selectedDataSet.batchCode : '',
                            "targetLayerId": Number(workflowState.selectedDataTarget.targetId),
                            "schema": dataLoaderFormData.schema.fieldValue,
                            "tableName": dataLoaderFormData.tableName.fieldValue,
                            "userDefinedFilters": filters,
                            "provPattern": {
                                "selectedPatternId": pattern
                            },
                            "fileRegistration": {
                                "blobContainer": dataLoaderFormData.blobContainer.fieldValue,
                                "fieldDelimiter": dataLoaderFormData.fieldDelimiter.fieldValue,
                                "extension": dataLoaderFormData.extension.fieldValue,
                                "isHeader": dataLoaderFormData.isHeader.fieldValue,
                                "manifestFileFlag": dataLoaderFormData.manifestFileFlag.fieldValue,
                                "wildcardExpression": "*",
                                "fileName": dataLoaderFormData.fileName.fieldValue,
                                "folderName": dataLoaderFormData.folderName.fieldValue,
                                "encoding": dataLoaderFormData.encoding.fieldValue,
                                "lineSeperator": dataLoaderFormData.lineSeperator.fieldValue,
                                "quoteAll": dataLoaderFormData.quoteAll.fieldValue,
                                "manifestUseAbsolutePath": dataLoaderFormData.manifestUseAbsolutePath.fieldValue,
                                "fileBatchSize": Number(dataLoaderFormData.fileBatchSize.fieldValue),
                                "deleteFlag": true,
                                "fileTimezone": dataLoaderFormData.fileTimezone.fieldValue.replace(" UTC", "")
                            }
                        }
                    }

                    dispatch(loaderActions.postDataLoaderRequest(postPayload))
                    setLoader(true)
                }
                else {
                    let postPayload = {
                        "businessMetadata": {
                            "owner": dataLoaderFormData.owner.fieldValue,
                            "description": dataLoaderFormData.description.fieldValue
                        },
                        "technicalMetadata": {
                            "extractorBatchCode": workflowState.selectedDataSet.batchCode ? workflowState.selectedDataSet.batchCode : '',
                            "targetLayerId": Number(workflowState.selectedDataTarget.targetId),
                            "schema": dataLoaderFormData.schema.fieldValue,
                            "tableName": dataLoaderFormData.tableName.fieldValue,
                            "userDefinedFilters": filters,
                            "provPattern": {
                                "selectedPatternId": pattern
                            },
                            "fileRegistration": null
                        }
                    }
                    setLoaderDescription(dataLoaderFormData.description.fieldValue)
                    dispatch(loaderActions.postDataLoaderRequest(postPayload))
                    setLoader(true)
                }

            }
        }

        // Mode is edit 
        if (batchCode && mode === constants.MODE.edit) {
            if (getDataTarget?.layerType === "LOAD_S3" || getDataTarget?.layerType === "LOAD_ADLS") {
                setLoaderDescription(dataLoaderFormData.description.fieldValue)
                let putPayload = {
                    "businessMetadata": {
                        "owner": dataLoaderFormData.owner.fieldValue,
                        "description": dataLoaderFormData.description.fieldValue
                    },
                    "technicalMetadata": {
                        "provPattern": {
                            "selectedPatternId": getDataLoader?.technicalMetadata.provPattern.selectedPatternId!
                        },
                        "userDefinedFilters": filters,
                        "fileRegistration": {
                            "blobContainer": dataLoaderFormData.blobContainer.fieldValue,
                            "fieldDelimiter": dataLoaderFormData.fieldDelimiter.fieldValue,
                            "extension": dataLoaderFormData.extension.fieldValue,
                            "isHeader": dataLoaderFormData.isHeader.fieldValue,
                            "manifestFileFlag": dataLoaderFormData.manifestFileFlag.fieldValue,
                            "wildcardExpression": "*",
                            "fileName": dataLoaderFormData.fileName.fieldValue,
                            "folderName": dataLoaderFormData.folderName.fieldValue,
                            "encoding": dataLoaderFormData.encoding.fieldValue,
                            "lineSeperator": dataLoaderFormData.lineSeperator.fieldValue,
                            "quoteAll": dataLoaderFormData.quoteAll.fieldValue,
                            "manifestUseAbsolutePath": dataLoaderFormData.manifestUseAbsolutePath.fieldValue,
                            "fileBatchSize": Number(dataLoaderFormData.fileBatchSize.fieldValue),
                            "deleteFlag": true,
                            "fileTimezone": dataLoaderFormData.fileTimezone.fieldValue.replace(" UTC", "")
                        }

                    }
                }
                dispatch(loaderActions.putDataLoaderRequest(batchCode, putPayload));
                setLoader(true)
                setLoaderNavigation(true);
            }
            else {
                setLoaderDescription(dataLoaderFormData.description.fieldValue)
                let putPayload = {
                    "businessMetadata": {
                        "owner": dataLoaderFormData.owner.fieldValue,
                        "description": dataLoaderFormData.description.fieldValue
                    },
                    "technicalMetadata": {
                        "userDefinedFilters": filters,
                        "provPattern": {
                            "selectedPatternId": pattern
                        },
                        "fileRegistration": null
                    }
                }
                dispatch(loaderActions.putDataLoaderRequest(batchCode, putPayload));
                setLoader(true)
                setLoaderNavigation(true);
            }

        }

        // get only time based triggers
        const selectedTriggers = triggers.filter((itm: any) => itm.cronExpression && !itm.edit)
        setTriggerList(selectedTriggers)

        // get only existing edit time based triggers
        const editedTriggers = triggers.filter((itm: any) => itm.cronExpression && itm.edit)
        setEditTriggerList(editedTriggers)

        // get only extractor based triggers
        const eventTrigger = triggers.filter((itm: any) => itm.extractor && !itm.edit)
        //setEventList(eventTrigger)
        setNewExtTrigger(eventTrigger);

        // get only existing extractor based triggers
        const eventEditTrigger = triggers.filter((itm: any) => itm.extractor && itm.edit)
        setEditEventList(eventEditTrigger)

        // get only loader based triggers
        const loaderTrigger = triggers.filter((itm: any) => itm.loader && !itm.edit)
        setLoaderList(loaderTrigger)

        // get only existing loader based triggers
        const eventLoaderTrigger = triggers.filter((itm: any) => itm.loader && itm.edit)
        setEditLoaderList(eventLoaderTrigger)

        // get only inbound webhook based triggers
        const inboundTrigger = triggers.filter((itm: any) => itm.webhook && !itm.edit)
        setInboundWebhookList(inboundTrigger)

        // get only existing inbound webhook based triggers
        const editInboundTrigger = triggers.filter((itm: any) => itm.webhook && itm.edit)
        setEditInboundWebhookList(editInboundTrigger)

        // get only outbound action
        const outboundAction = actions.filter((itm: any) => itm.outboundWebhook && !itm.edit)
        setActionList(outboundAction)

        // get only existing outbound action
        const outboundEditAction = actions.filter((itm: any) => itm.outboundWebhook && itm.edit)
        setEditActionList(outboundEditAction)

        setLayerName(dataLoaderFormData.dataTargetName.fieldValue)

    }


    const viewLoader = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/ViewDataLoader/${batchCode}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    }

    const onFilterChange = (inputFilters: userDefinedFilteringList) => {
        const newFilters = userDefinedFilters.map((item) => {
            if (item.key === inputFilters.key) return inputFilters;
            return item;
        })
        setUserDefinedFilters(newFilters)
    }

    const adduserDefinedFilter = () => {
        setUserDefinedFilters(
            userDefinedFilters.concat({
                key: Date.now(),
                field: '',
                operation: '',
                filterValue: ''
            })
        )
    }

    const deleteUserDefinedFilter = (id: number) => {
        const filterItem = userDefinedFilters.filter((item) => item.key !== id)
        setUserDefinedFilters(filterItem)
    }

    const handleUserDefinedFilterFieldChange = (event: SelectChangeEvent, key: number) => {
        onFilterChange({ key: key, field: event.target.value, operation: '', filterValue: '' })
    }

    const handleUserDefinedFilterOperationChange = (event: SelectChangeEvent, key: number) => {
        onFilterChange({
            key: key,
            field: userDefinedFilters.filter((item) => item.key === key)[0].field,
            operation: event.target.value,
            filterValue: userDefinedFilters.filter((item) => item.key === key)[0].filterValue
        })
    }

    const handleUserDefinedFilterValueChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: number) => {
        onFilterChange({
            key: key,
            field: userDefinedFilters.filter((item) => item.key === key)[0].field,
            operation: userDefinedFilters.filter((item) => item.key === key)[0].operation,
            filterValue: event.target.value
        })
    }

    const handleLoadingTypeChange = (e: SelectChangeEvent<string>) => {
        let field: IFormDropDown = {
            fieldValue: e.target.value,
            isError: false,
            errorMsg: "",
        };

        setDataLoaderFormData({ ...dataLoaderFormData, [e.target.name]: field });
        setLoaderChanges(true);
    };

    const onHandleBlur = (event: {}) => {
        const e = event as React.FocusEvent<HTMLInputElement>;
        (e.target.value === "" || !e.target.value) && required
            ? setTypeError(true)
            : setTypeError(false);
        setDataLoaderFormData(dataLoaderFormData);
    };

    const viewExtractor = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/ViewDataExtractor/${dataLoaderFormData.dataExtractorName.fieldValue}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }

    }

    const viewTarget = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/ViewDataTarget/${viewTargetID}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    }

    const editLoader = (event: React.MouseEvent<HTMLButtonElement>) => {
        let code: string = encodeURIComponent(batchCode ?? '');
        const url = `/EditDataLoader/${code}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    }

    const deleteParams: IDeleteParams = {
        batchCodes: [batchCode!],
    };

    const deleteLoader = () => {
        dispatch(deleteLoaderReq(deleteParams));
        navigate(`/DataLoaderList`);
    }

    // onchange for trigger
    const onLoaderTriggerChange = (inputTrigger: triggerTypeList) => {
        const newTriggers = triggers.map((item) => {
            if (item.key === inputTrigger.key) return inputTrigger;
            return item;
        })
        setTriggers(newTriggers)
    }

    // add new trigger
    const addTrigger = () => {
        setTriggers(
            triggers.concat({
                key: Date.now()
            })
        )
    }

    // edit time trigger
    const editTimeTrigger = (item: any) => {
        setTriggers(
            triggers.concat({
                key: Date.now(),
                ...item,
                edit: true
            })
        )
    }

    // edit outbound trigger
    const editOutbound = (item: any) => {
        setActions(
            actions.concat({
                key: Date.now(),
                ...item,
                edit: true
            })
        )
    }

    // edit trigger
    const editExtractor = (item: any) => {
        setTriggers(
            triggers.concat({
                key: Date.now(),
                ...item,
                edit: true
            })
        )
    }

    // delete trigger
    const deleteTrigger = (id: number) => {
        const triggerItem = triggers.filter((item) => item.key !== id)
        setTriggers(triggerItem)

    }

    // close modal for triggers
    const handleClose = () => {
        setOpen(false);
        setOpenOutbound(false)
        setOpenTimeTrigger(false)
        setOpenConfirmationDialog(false)
    }

    // onchange for action
    const onActionChange = (inputAction: actionTypeList) => {
        const newActions = actions.map((item: any) => {
            if (item.key === inputAction.key) return inputAction;
            return item;
        })
        setActions(newActions)
    }

    // add new action
    const addAction = () => {
        setActions(
            actions.concat({
                key: Date.now()
            })
        )
    }

    // delete action
    const deleteAction = (id: number) => {
        const actionItem = actions.filter((item: any) => item.key !== id)
        setActions(actionItem)

    }

    const handleExtractorDelete = (item: any) => {
        setOpen(false);
        dispatch(deleteEventsReq(item));
    }

    const handleOutboundDelete = (item: any) => {
        setOpenOutbound(false);
        dispatch(webhookDispatch.deleteOutboundWebhookReq(item));
    }

    const handleJobDelete = (item: any) => {
        setOpenTimeTrigger(false);
        dispatch(deleteExtJobSchedulesReq(item));
    }

    const goBack = () => {
        dispatch(loaderActions.putDataLoaderReset())
        window.history.back();

    };


    let grantee = getDataLoader?.businessMetadata.owner.toLowerCase();
    let tableId = getDataLoader?.technicalMetadata.extractorBatchCode.substring('b_stg_stg_'.length).toLowerCase();

    const renewOverridesLink = () => {
        window.location.href = "https://riotinto.service-now.com/esc?id=sc_cat_item&sys_id=36d0848487c4b1d0f38c64673cbb35fe";
    }

    return (
        <>
            <Formik
                initialValues={{}}
                onSubmit={() => {
                }} >
                <div style={{ marginBottom: '200px' }}>
                    <Back />

                    <h1 style={{ textAlign: "left" }}>{mode} Data Loader &nbsp;
                        {!taskDisabled && mode === constants.MODE.view ? <Tooltip title="Inactive">
                            <WarningAmberRoundedIcon fontSize="medium" />
                        </Tooltip> : null}
                    </h1>
                    <Form>
                        {/* adding skeleton screen on loading */}
                        {(mode !== constants.MODE.add && (loadingDataLoader || getDataTargetPending || getExtractorPending)) || (mode === constants.MODE.add && getExtractorPending) ?
                            <Box>
                                <Grid container spacing={4} >
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                </Grid>

                            </Box> :
                            <Grid container spacing={4}>
                                <Grid item xs={6}>
                                    <FormControl sx={{ m: 1 }} fullWidth>
                                        <DataField id="a0dc73e5-500c-419a-a5d7-91bb2fb8f954"
                                            label='Name'
                                            name='description'
                                            required={true}
                                            value={dataLoaderFormData.description.fieldValue}
                                            onChange={handleChange}
                                            error={dataLoaderFormData.description.isError}
                                            readOnly={(mode === constants.MODE.view) ? true : false}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl sx={{ m: 1 }} fullWidth>
                                        {(mode !== constants.MODE.view) &&
                                            <Box>
                                                <Autocomplete
                                                    options={idpUsersProduction}
                                                    onChange={(event, value) => {
                                                        let v = value as IUser;
                                                        dataLoaderFormData.owner.fieldValue = (v === null) ? '' : v.userName;
                                                        setOwnerValue((v === null) ? '' : v.userName)
                                                    }}
                                                    getOptionLabel={(option) =>
                                                        option === undefined ? " " : option.userName
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.userName === value.userName}
                                                    value={functions.getIUser(dataLoaderFormData.owner.fieldValue)}
                                                    disabled={(mode === constants.MODE.view) ? true : false}
                                                    renderInput={(params) => (
                                                        <TextField {...params}
                                                            name="Owner"
                                                            label='Owner'
                                                            required
                                                            value={dataLoaderFormData.owner.fieldValue}
                                                            error={dataLoaderFormData.owner.isError}
                                                        />

                                                    )}
                                                />
                                            </Box>
                                        }

                                        {(mode === constants.MODE.view) && <DataField id="57933f88-6f5a-4ae1-9611-fa31b68824f2"
                                            label='Owner'
                                            name='owner'
                                            value={dataLoaderFormData.owner.fieldValue}
                                            readOnly={true}
                                        />
                                        }
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl sx={{ m: 1 }} fullWidth>
                                        <DataField id="f203ef4b-afa2-4c24-af6d-598aa3d3cd35"
                                            name='dataExtractor'
                                            label="Data Extractor"
                                            required={true}
                                            value={mode === constants.MODE.add ? dataLoaderFormData.dataExtractorName.fieldValue : (getDataExtractor ? getDataExtractor?.businessMetadata?.description : 'Not Available')}
                                            error={dataLoaderFormData.dataExtractorName.isError}
                                            readOnly={true}
                                        />
                                    </FormControl>

                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl sx={{ m: 1 }} fullWidth>
                                        <DataField id="835b5a55-ba71-4441-b544-4bca687237ec"
                                            name='dataTarget'
                                            label="Data Target"
                                            required={true}
                                            value={mode === constants.MODE.add ? dataLoaderFormData.dataTargetName.fieldValue : (getDataTarget ? getDataTarget?.name : 'Not Available')}
                                            error={dataLoaderFormData.dataTargetName.isError}
                                            readOnly={true}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl sx={{ m: 1 }} fullWidth>
                                        <DataField id="35f88cf3-d43c-462a-9e67-c4c066db9520"
                                            label='Schema'
                                            name='schema'
                                            required={false}
                                            value={dataLoaderFormData.schema.fieldValue}
                                            onChange={handleChange}
                                            error={dataLoaderFormData.schema.isError}
                                            readOnly={(mode === constants.MODE.view) ? true : false}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl sx={{ m: 1 }} fullWidth>
                                        <DataField id="9852449c-6716-4ee2-90d9-47d5f00b2611"
                                            label='Table'
                                            name='tableName'
                                            required={false}
                                            value={dataLoaderFormData.tableName.fieldValue}
                                            onChange={handleChange}
                                            error={dataLoaderFormData.tableName.isError}
                                            readOnly={(mode === constants.MODE.view) ? true : false}
                                        />
                                    </FormControl>
                                </Grid>
                                {workflowState.selectedDataTarget?.layerType === "LOAD_REDSHIFT" || getDataTarget?.layerType === "LOAD_REDSHIFT" ?
                                    <Grid item xs={4}>
                                        <FormControl sx={{ m: 1 }} fullWidth>
                                            <DataField id="be4e6ff4-df95-49b1-8aa7-26f5fe6c524d"
                                                label='Role'
                                                name='iamRole'
                                                required={true}
                                                value={dataLoaderFormData.iamRole.fieldValue}
                                                onChange={handleChange}
                                                error={dataLoaderFormData.iamRole.isError}
                                                readOnly={(mode === constants.MODE.view) ? true : false}
                                            />
                                        </FormControl>
                                    </Grid> : ''}
                                <Grid item xs={4}>
                                    <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                        <InputLabel id="loading-type-label" sx={{ pr: 1 }}>
                                            <div style={{ backgroundColor: "#F5F5F5", paddingRight: "0.1em" }}>Loading Type
                                                <Tooltip title="Delta mode is the normal mode of operation. 'Always Rebase' means the Data Set is cleared from the Data Target and
                                                 reloaded completely every run.">
                                                    <IconButton>
                                                        <InfoIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </InputLabel>

                                        <Select
                                            labelId="loading-type-label"
                                            label="Loading Type"
                                            name="loadingType"
                                            required

                                            error={typeError}
                                            value={dataLoaderFormData.loadingType.fieldValue}
                                            onBlur={onHandleBlur}
                                            inputProps={{
                                                readOnly: mode === constants.MODE.view,
                                            }}
                                            disabled={mode === constants.MODE.view}
                                            variant={
                                                mode === constants.MODE.view ? "standard" : "outlined"
                                            }
                                            onChange={handleLoadingTypeChange}

                                        >
                                            <MenuItem value="delta">Delta</MenuItem>
                                            <MenuItem value="rebase">Always Rebase</MenuItem>

                                        </Select>
                                    </FormControl>

                                </Grid>
                                {(mode === constants.MODE.add && workflowState.selectedDataTarget?.layerType === "LOAD_ADLS" || workflowState.selectedDataTarget?.layerType === "LOAD_S3") ||
                                    (mode !== constants.MODE.add && getDataTarget?.layerType === "LOAD_S3" || getDataTarget?.layerType === "LOAD_ADLS") ?
                                    <>
                                        {getDataTargetPending ? <Grid item xs={12}>Loading...</Grid> :
                                            <>

                                                <Grid item xs={3}>
                                                    <FormControl sx={{ m: 1 }} fullWidth>
                                                        <DataField id="933668f2-dc94-4763-bb64-ef98ca7a5139"
                                                            label={workflowState.selectedDataTarget?.layerType === "LOAD_ADLS" || getDataTarget?.layerType === "LOAD_ADLS" ? 'Container' : 'Bucket Name'}
                                                            name='blobContainer'
                                                            required={true}
                                                            value={dataLoaderFormData.blobContainer.fieldValue}
                                                            onChange={handleChange}
                                                            readOnly={(mode === constants.MODE.view) ? true : false}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </>}
                                    </>
                                    : ''}


                                {(mode === constants.MODE.add && workflowState.selectedDataTarget?.layerType === "LOAD_ADLS" || workflowState.selectedDataTarget?.layerType === "LOAD_S3") ||
                                    (mode !== constants.MODE.add && getDataTarget?.layerType === "LOAD_S3" || getDataTarget?.layerType === "LOAD_ADLS") ?
                                    <>
                                        {getDataTargetPending ? <Grid item xs={12}>Loading...</Grid> :
                                            <>
                                                <Grid item xs={4}>
                                                    <Button id="bbd2b292-9443-4e11-9cc8-5e4e0946bb13" sx={{ m: 1 }} color="primary" size="small" onClick={() => setOpenSettings(!openSettings)}>
                                                        Advanced Settings +
                                                    </Button>
                                                </Grid>
                                                {openSettings ?
                                                    <>
                                                        <Grid item xs={12}>
                                                            <h2>Technical</h2>
                                                        </Grid>

                                                        <Grid item xs={3}>
                                                            <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"} required={true}>
                                                                <InputLabel htmlFor='fieldDelimiter'>Delimiter</InputLabel>
                                                                <Select
                                                                    label='fieldDelimiter'
                                                                    name='fieldDelimiter'
                                                                    id='fieldDelimiter'
                                                                    disabled={mode === constants.MODE.view}
                                                                    variant={
                                                                        mode === constants.MODE.view ? "standard" : "outlined"
                                                                    }
                                                                    onChange={onDropdownChange}
                                                                    value={dataLoaderFormData.fieldDelimiter.fieldValue}
                                                                    fullWidth
                                                                    defaultValue=","
                                                                >
                                                                    <MenuItem key='0' value=',' >Comma (,)</MenuItem>
                                                                    <MenuItem key='1' value=';'>Semi-colon (;)</MenuItem>
                                                                    <MenuItem key='2' value='\t'>Tab (\t)</MenuItem>

                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"} required={true}>
                                                                <InputLabel htmlFor='extension'>Extension</InputLabel>
                                                                <Select
                                                                    labelId='extension'
                                                                    label='extension'
                                                                    disabled={mode === constants.MODE.view}
                                                                    variant={
                                                                        mode === constants.MODE.view ? "standard" : "outlined"
                                                                    }
                                                                    name='extension'
                                                                    id='extension'
                                                                    onChange={onDropdownChange}
                                                                    value={dataLoaderFormData.extension.fieldValue}
                                                                    fullWidth
                                                                    defaultValue="csv"
                                                                >
                                                                    <MenuItem key='0' value='csv'>CSV</MenuItem>
                                                                    <MenuItem key='1' value='tsv'>TSV</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"} required={true}>
                                                                <InputLabel id='manifestFileFlag'>Manifest File</InputLabel>
                                                                <Select
                                                                    labelId='manifestFileFlag'
                                                                    label='manifestFileFlag'
                                                                    id='manifestFileFlag'
                                                                    name='manifestFileFlag'
                                                                    disabled={mode === constants.MODE.view}
                                                                    variant={
                                                                        mode === constants.MODE.view ? "standard" : "outlined"
                                                                    }
                                                                    onChange={onDropdownChange}
                                                                    value={dataLoaderFormData.manifestFileFlag.fieldValue}
                                                                    fullWidth
                                                                >
                                                                    <MenuItem key='0' value='true'>Yes</MenuItem>
                                                                    <MenuItem key='1' value='false'>No</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"} required={true}>
                                                                <InputLabel id="isHeader">Header</InputLabel>
                                                                <Select
                                                                    labelId="isHeader"
                                                                    label="isHeader"
                                                                    name="isHeader"
                                                                    defaultValue='true'
                                                                    value={dataLoaderFormData.isHeader.fieldValue}
                                                                    disabled={mode === constants.MODE.view}
                                                                    inputProps={{
                                                                        readOnly: mode === constants.MODE.view,
                                                                    }}
                                                                    variant={
                                                                        mode === constants.MODE.view ? "standard" : "outlined"
                                                                    }
                                                                    onChange={onDropdownChange}
                                                                >
                                                                    <MenuItem key='0' value="true">Yes</MenuItem>
                                                                    <MenuItem key='1' value="false">No</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <FormControl sx={{ m: 1 }} fullWidth>
                                                                <DataField id="1a4d0eaa-23fd-47b7-8de2-9f17b2317625"
                                                                    label='File Name'
                                                                    name='fileName'
                                                                    required={true}
                                                                    value={dataLoaderFormData.fileName.fieldValue}
                                                                    onChange={handleChange}
                                                                    readOnly={(mode === constants.MODE.view) ? true : false}
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <FormControl sx={{ m: 1 }} fullWidth >
                                                                <DataField id="5e240c4b-36e3-40e2-807f-c3794dc9765c"
                                                                    label='Folder Name'
                                                                    name='folderName'
                                                                    required={true}
                                                                    value={dataLoaderFormData.folderName.fieldValue}
                                                                    onChange={handleChange}
                                                                    readOnly={(mode === constants.MODE.view) ? true : false}
                                                                />
                                                            </FormControl>
                                                        </Grid>

                                                        <Grid item xs={3}>
                                                            <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"} required={true}>
                                                                <InputLabel id='quoteAll'>Quote All</InputLabel>
                                                                <Select
                                                                    labelId='quoteAll'
                                                                    label='quoteAll'
                                                                    disabled={mode === constants.MODE.view}
                                                                    variant={
                                                                        mode === constants.MODE.view ? "standard" : "outlined"
                                                                    }
                                                                    id='quoteAll'
                                                                    name='quoteAll'
                                                                    onChange={onDropdownChange}
                                                                    value={dataLoaderFormData.quoteAll.fieldValue}
                                                                    fullWidth
                                                                    defaultValue='quote_minimal'
                                                                >
                                                                    <MenuItem key='0' value='none' selected>None</MenuItem>
                                                                    <MenuItem key='1' value='quote_minimal'>Fields with Special Characters</MenuItem>
                                                                    <MenuItem key='1' value='quote_all'>All</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"} required={true}>
                                                                <InputLabel id='manifestUseAbsolutePath'>Manifest Use Absolute Path</InputLabel>

                                                                <Select
                                                                    labelId='manifestUseAbsolutePath'
                                                                    label='Manifest Use Absolute Path'
                                                                    id='manifestUseAbsolutePath'
                                                                    name='manifestUseAbsolutePath'
                                                                    disabled={mode === constants.MODE.view}
                                                                    variant={
                                                                        mode === constants.MODE.view ? "standard" : "outlined"
                                                                    }
                                                                    onChange={onDropdownChange}
                                                                    value={dataLoaderFormData.manifestUseAbsolutePath.fieldValue}
                                                                    fullWidth
                                                                    defaultValue="true"
                                                                >
                                                                    <MenuItem key='0' value='true'>True</MenuItem>
                                                                    <MenuItem key='1' value='false'>False</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <FormControl sx={{ m: 1 }} fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                                                <DataField id="9f7803dc-3a7d-4697-a6ab-41ebfcff4f0f"
                                                                    label='File Batch Size'
                                                                    name='fileBatchSize'
                                                                    required={true}
                                                                    value={dataLoaderFormData.fileBatchSize.fieldValue}
                                                                    onChange={handleChange}
                                                                    // error={dataLoaderFormData.fileBatchSize.isError}
                                                                    readOnly={(mode === constants.MODE.view) ? true : false}
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <FormControl fullWidth>
                                                                <InputLabel id="time-label">Timezone</InputLabel>
                                                                <Select
                                                                    labelId="time-label"
                                                                    label="Timezone"
                                                                    name="fileTimezone"
                                                                    value={dataLoaderFormData.fileTimezone.fieldValue}
                                                                    onChange={onDropdownChange}
                                                                    disabled={mode === constants.MODE.view}
                                                                    variant={
                                                                        mode === constants.MODE.view ? "standard" : "outlined"
                                                                    }
                                                                >
                                                                    {timeZoneValues.map((item, index) => {
                                                                        return (
                                                                            <MenuItem value={item}> {item} </MenuItem>
                                                                        )
                                                                    })}
                                                                    <MenuItem value={dataLoaderFormData.fileTimezone.fieldValue}>{dataLoaderFormData.fileTimezone.fieldValue}</MenuItem>

                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                    </> : ''}
                                            </>
                                        }
                                    </> : ''}
                                {mode === constants.MODE.add ?
                                    <Grid item xs={12}>
                                        <>
                                            <h2>Filters</h2>
                                            {mode === constants.MODE.add ? <Box display="flex" justifyContent="flex-start" style={{ marginBottom: '1em' }}>
                                                <Button id="529f8076-98a5-427e-ab5a-b6dca6d54e45" color="primary" variant="contained" onClick={adduserDefinedFilter}>Add New Filter</Button>
                                            </Box> : ""
                                            }
                                            <div>
                                                {userDefinedFilters.map((filter, index) => (
                                                    <React.Fragment key={index}>
                                                        <Box sx={{ border: 1, borderColor: 'divider', padding: 2, width: '100%', display: 'block' }}>
                                                            <Grid container spacing={5} alignItems="center">
                                                                <Grid item xs={3}>
                                                                    <FormControl fullWidth >
                                                                        <InputLabel id="userDefinedFilteringFieldLabel">Field</InputLabel>
                                                                        <Select
                                                                            name='userDefinedFilteringField'
                                                                            label='Field'
                                                                            value={filter.field}
                                                                            onChange={(event) => handleUserDefinedFilterFieldChange(event, filter.key)}
                                                                            labelId='userDefinedFilteringFieldLabel'
                                                                            fullWidth
                                                                            required
                                                                            disabled={mode === "View" ? true : false}
                                                                            sx={{ textAlign: 'left' }}
                                                                            variant={mode === constants.MODE.view ? 'standard' : 'outlined'}

                                                                        >
                                                                            {
                                                                                extractorColumns && extractorColumns.map((item: any, index: number) => {
                                                                                    return (
                                                                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                                                                    );
                                                                                })
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="userDefinedFilteringOperationLabel">Operation</InputLabel>
                                                                        <Select
                                                                            name="filterOperation"
                                                                            value={filter.operation}
                                                                            label="Operation"
                                                                            labelId='userDefinedFilteringOperationLabel'
                                                                            inputProps={{
                                                                                readOnly: mode === constants.MODE.view
                                                                            }}
                                                                            fullWidth
                                                                            disabled={mode === "View" ? true : false}
                                                                            sx={{ textAlign: 'left' }}
                                                                            variant={mode === constants.MODE.view ? 'standard' : 'outlined'}
                                                                            onChange={(event) => handleUserDefinedFilterOperationChange(event, filter.key)}
                                                                        >
                                                                            <MenuItem value='='>is equal to</MenuItem>
                                                                            <MenuItem value='>'>is greater than</MenuItem>
                                                                            <MenuItem value='<'>is less than</MenuItem>
                                                                            <MenuItem value='>='>is greater than or equal to</MenuItem>
                                                                            <MenuItem value='<='>is less than or equal to</MenuItem>
                                                                            <MenuItem value='<>'>is not equal to</MenuItem>
                                                                            <MenuItem value='LIKE'>is like</MenuItem>
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                    <DataField id="ea1bce09-eb5d-4a4a-bc64-9828a9f016bd"
                                                                        label='Value'
                                                                        name='filterValue'
                                                                        required={false}
                                                                        value={filter.filterValue}
                                                                        disabled={mode === "View" ? true : false}
                                                                        onChange={(event) => handleUserDefinedFilterValueChange(event, filter.key)}
                                                                        error={dataLoaderFormData.tableName.isError}
                                                                        readOnly={(mode === constants.MODE.view) ? true : false}
                                                                    />
                                                                </Grid>
                                                                {mode === "View" ? "" :
                                                                    <Grid item xs={1}>
                                                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => deleteUserDefinedFilter(filter.key)} >
                                                                            <DeleteSharpIcon />
                                                                        </IconButton>
                                                                    </Grid>}

                                                            </Grid>
                                                        </Box>

                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </>
                                        {/* Triggers */}
                                        {mode === constants.MODE.add ?
                                            <>
                                                <h2>Triggers</h2>
                                                <p>Tasks must be run manually unless a trigger is added to run repeatedly.</p>

                                                <Box display="flex" justifyContent="flex-start" style={{ marginBottom: '1em' }}>
                                                    <Button id="ce962ed1-bc3f-4089-a2c1-291d736e0046" color="primary" variant="contained" onClick={addTrigger}>Add New </Button>
                                                </Box>
                                                <div>
                                                    {triggers.map((trigger) => (
                                                        <React.Fragment key={trigger.key}>
                                                            {trigger.key != 0 ?
                                                                <Box sx={{ border: 1, borderColor: 'divider', padding: 2, width: '100%', display: 'block' }}>
                                                                    <Grid container spacing={5} alignItems="center">
                                                                        <TriggerRow value={trigger} onChange={onLoaderTriggerChange} type={'loader'} />
                                                                        <Grid item xs={1}>
                                                                            <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => deleteTrigger(trigger.key)} >
                                                                                <DeleteSharpIcon />
                                                                            </IconButton>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Box>
                                                                : <></>}
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </> : ''}
                                        <Grid item xs={12}>
                                            {mode === constants.MODE.add ?
                                                <>
                                                    <h2>Actions</h2>
                                                    <p>Actions to take once the task has successfully completed.</p>
                                                </>
                                                : ""}
                                            {mode === constants.MODE.view ? '' :
                                                <>
                                                    <Box display="flex" justifyContent="flex-start" style={{ marginBottom: '1em' }}>
                                                        <Button id="7ff55b14-8e33-4060-9fa9-a0261a8053ae" color="primary" variant="contained" onClick={addAction}>
                                                            Add New </Button>
                                                    </Box>
                                                    <div>
                                                        {actions.map((actionItem: any) => (
                                                            <React.Fragment key={actionItem.key}>
                                                                <Box sx={{ border: 1, borderColor: 'divider', padding: 2, width: '100%', display: 'block' }}>
                                                                    <Grid container spacing={5} alignItems="center">
                                                                        <ActionRow value={actionItem} onChange={onActionChange} />
                                                                        <Grid item xs={1}>
                                                                            <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => deleteAction(actionItem.key)} >
                                                                                <DeleteSharpIcon />
                                                                            </IconButton>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Box>

                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                                </>}
                                        </Grid>
                                    </Grid>

                                    : <></>
                                }

                                {/******************* View ****************/}

                                {mode === "View" ? <> <Grid item xs={12}>
                                                {userDefinedFilters && userDefinedFilters[0].field ? <h2>Filters</h2> : ''}
                                                <FormControl sx={{ m: 1 }} fullWidth>
                                                    {userDefinedFilters && userDefinedFilters[0].field && userDefinedFilters.map((filter, index) => (
                                                        <React.Fragment key={index}>
                                                            <Box sx={{ padding: 2, width: '100%' }}>
                                                                <Grid container spacing={5} alignItems="center">
                                                                    <Grid item xs={3}>
                                                                        <FormControl fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                                                            <InputLabel id="userDefinedFilteringFieldLabel">Field</InputLabel>
                                                                            <Select
                                                                                name='userDefinedFilteringField'
                                                                                label='Field'
                                                                                value={filter.field}
                                                                                onChange={(event) => handleUserDefinedFilterFieldChange(event, filter.key)}
                                                                                labelId='userDefinedFilteringFieldLabel'
                                                                                fullWidth
                                                                                required
                                                                                readOnly={(mode === constants.MODE.view) ? true : false}
                                                                                disabled={mode === "View" ? true : false}
                                                                                sx={{ textAlign: 'left' }}
                                                                                variant={mode === constants.MODE.view ? 'standard' : 'outlined'}

                                                                            >
                                                                                {
                                                                                    extractorColumns && extractorColumns.map((item: any, index: number) => {
                                                                                        return (
                                                                                            <MenuItem key={index} value={item}>{item}</MenuItem>
                                                                                        );
                                                                                    })
                                                                                }
                                                                                {/* <MenuItem>Testing</MenuItem> */}

                                                                            </Select>
                                                                        </FormControl>
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                        <FormControl fullWidth variant={(mode === constants.MODE.view) ? "standard" : "outlined"}>
                                                                            <InputLabel id="userDefinedFilteringOperationLabel">Operation</InputLabel>
                                                                            <Select
                                                                                name="filterOperation"
                                                                                value={filter.operation}
                                                                                label="Operation"
                                                                                labelId='userDefinedFilteringOperationLabel'
                                                                                inputProps={{
                                                                                    readOnly: mode === constants.MODE.view
                                                                                }}
                                                                                fullWidth
                                                                                disabled={mode === "View" ? true : false}
                                                                                sx={{ textAlign: 'left' }}
                                                                                variant={mode === constants.MODE.view ? 'standard' : 'outlined'}
                                                                                onChange={(event) => handleUserDefinedFilterOperationChange(event, filter.key)}
                                                                            >
                                                                                <MenuItem value='='>is equal to</MenuItem>
                                                                                <MenuItem value='>'>is greater than</MenuItem>
                                                                                <MenuItem value='<'>is less than</MenuItem>
                                                                                <MenuItem value='>='>is greater than or equal to</MenuItem>
                                                                                <MenuItem value='<='>is less than or equal to</MenuItem>
                                                                                <MenuItem value='<>'>is not equal to</MenuItem>
                                                                                <MenuItem value='LIKE'>is like</MenuItem>
                                                                            </Select>
                                                                        </FormControl>
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                        <DataField id="ef428b3e-4a48-4192-8ac8-d803442ebcaf"
                                                                            label='Value'
                                                                            name='filterValue'
                                                                            required={false}
                                                                            value={filter.filterValue}
                                                                            disabled={mode === "View" ? true : false}
                                                                            onChange={(event) => handleUserDefinedFilterValueChange(event, filter.key)}
                                                                            error={dataLoaderFormData.tableName.isError}
                                                                            readOnly={(mode === constants.MODE.view) ? true : false}
                                                                        />
                                                                    </Grid>
                                                                    {mode === "View" ? "" :
                                                                        <Grid item xs={1}>
                                                                            <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => deleteUserDefinedFilter(filter.key)} >
                                                                                <DeleteSharpIcon />
                                                                            </IconButton>
                                                                        </Grid>}

                                                                </Grid>
                                                            </Box>

                                                        </React.Fragment>
                                                    ))}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {outboundPendingList || eventsPending || inboundPendingList ? <Grid item xs={12}>Loading...</Grid> :
                                                    <>
                                                        {(jobList && jobList.length > 0) ? <>
                                                            <h2>Next Runtime</h2>
                                                        </> : ""}

                                                        <>
                                                            {jobList && jobList.length > 0 && jobList?.map((job: any, index: number) => {
                                                                return <div key={index}>{cronstrue.toString(job.cronExpression)} (UTC {job.timezone})
                                                                </div>

                                                            })}

                                                        </>
                                                        {(jobList && jobList.length > 0) || (eventList && eventList.length > 0) ? <>
                                                            <h2>Triggers</h2>
                                                            {/* <p>Triggers for the task to commence.</p> */}
                                                        </> : ""}

                                                        {jobList && jobList.length > 0 && jobList?.map((job: any, index: number) => {
                                                            return <div key={index}>{cronstrue.toString(job.cronExpression)} (UTC {job.timezone})
                                                            </div>

                                                        })}
                                                        {eventList && eventList.length > 0 && eventList?.map((task: any, index: number) => {
                                                            return <div key={index}> {task.eventType === "LOAD_TASK.SUCCESS" ? "Events: " : "Inbound Webhook: "}
                                                                {task.description ? task.description : ''}
                                                            </div>
                                                        })}

                                                        {outbound && outbound.length > 0 ?
                                                            <>
                                                                <h2>Actions</h2>
                                                                {/* <p>Actions to take once the task has successfully completed. </p>                                       */}
                                                                {outbound && outbound.length > 0 && outbound.map((task: any, index: number) => {
                                                                    return <div key={index}> Webhook: {task.eventActionValue ? task.eventActionValue : ''} {task.outboundWebhookHeader ? ` - ${task.outboundWebhookHeader}` : ''}
                                                                    </div>
                                                                })}
                                                            </>
                                                            : ''}
                                                    </>
                                                }
                                    </Grid> </> : <></>}

                                {mode === "View" && (
                                    <Grid item xs={12}>
                                        <LoaderStatus
                                            batchCode={batchCode || ''}
                                            rebaseAllowed={true}
                                            enabled={taskDisabled}
                                        />
                                        <Button
                                            id="3fb94113-227f-4496-b57c-19f1d6eaa600"
                                            color="primary"
                                            variant="contained"
                                            onClick={viewExtractor}
                                            sx={{ m: 1 }}
                                        >
                                            View Extractor
                                        </Button>
                                        <Button
                                            id="658c2943-5d0e-48ad-b9ae-c42a4b4e1e0a"
                                            color="primary"
                                            variant="contained"
                                            onClick={viewTarget}
                                            sx={{ m: 1 }}
                                        >
                                            View Target
                                        </Button>

                                        {(isAdmin || dataLoaderFormData.owner.fieldValue.toLowerCase() === userMail.toLowerCase()) && (
                                            <>
                                                {(
                                                    <Button
                                                        id="086b5f3d-19ab-4b8f-bb20-e255ca464fa2"
                                                        color="primary"
                                                        variant="contained"
                                                        onClick={editLoader}
                                                        sx={{ m: 1 }}
                                                    >
                                                        Edit
                                                    </Button>
                                                )}
                                            </>
                                        )}

                                        {isAdmin && (<>
                                            <Button id="deleteBtn" color="primary" variant="contained" onClick={() => setOpenConfirmationDialog(true)} sx={{ m: 1 }}>
                                                Delete
                                            </Button>
                                            <>
                                                <CustomizedDialogs
                                                    dialogHeight=''
                                                    modalSize="md"
                                                    key="deleteLoader"
                                                    modalTitle="Delete Confirmation"
                                                    isOpen={openConfirmationDialog}
                                                    onClose={handleClose}
                                                    footerAction={
                                                        <Stack direction="row" spacing={2}>
                                                            <Button id="yesBtn" color="primary" onClick={() => deleteLoader()} autoFocus>
                                                                Yes
                                                            </Button>
                                                            <Button id="noBtn" color="primary" onClick={handleClose}>
                                                                No
                                                            </Button>
                                                        </Stack>
                                                    }
                                                >
                                                    <>Are you sure you want to delete the loader?</>
                                                </CustomizedDialogs>
                                            </>
                                        </>)
                                        }
                                    </Grid>
                                )}

                                {/******************* Edit Loaders ****************/}

                                {mode === "Edit" ?
                                    <>
                                        <Grid item xs={12}>
                                            <h2>Filters</h2>
                                            <Box display="flex" justifyContent="flex-start" style={{ marginBottom: '1em' }}>
                                                <Button id="529f8076-98a5-427e-ab5a-b6dca6d54e45" color="primary" variant="contained" onClick={adduserDefinedFilter}>Add New Filter</Button>
                                            </Box>
                                            <div>
                                                {userDefinedFilters.map((filter, index) => (
                                                    <React.Fragment key={index}>
                                                        <Box sx={{ border: 1, borderColor: 'divider', padding: 2, width: '100%', display: 'block' }}>
                                                            <Grid container spacing={5} alignItems="center">
                                                                <Grid item xs={3}>
                                                                    <FormControl fullWidth >
                                                                        <InputLabel id="userDefinedFilteringFieldLabel">Field</InputLabel>
                                                                        <Select
                                                                            name='userDefinedFilteringField'
                                                                            label='Field'
                                                                            value={filter.field}
                                                                            onChange={(event) => handleUserDefinedFilterFieldChange(event, filter.key)}
                                                                            labelId='userDefinedFilteringFieldLabel'
                                                                            fullWidth
                                                                            required
                                                                            sx={{ textAlign: 'left' }}
                                                                            variant={mode === constants.MODE.view ? 'standard' : 'outlined'}
                                                                        >
                                                                            {
                                                                                extractorColumns && extractorColumns.map((item: any, index: number) => {
                                                                                    return (
                                                                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                                                                    );
                                                                                })
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="userDefinedFilteringOperationLabel">Operation</InputLabel>
                                                                        <Select
                                                                            name="filterOperation"
                                                                            value={filter.operation}
                                                                            label="Operation"
                                                                            labelId='userDefinedFilteringOperationLabel'
                                                                            inputProps={{
                                                                                readOnly: mode === constants.MODE.view
                                                                            }}
                                                                            fullWidth
                                                                            sx={{ textAlign: 'left' }}
                                                                            variant={mode === constants.MODE.view ? 'standard' : 'outlined'}
                                                                            onChange={(event) => handleUserDefinedFilterOperationChange(event, filter.key)}
                                                                        >
                                                                            <MenuItem value='='>is equal to</MenuItem>
                                                                            <MenuItem value='>'>is greater than</MenuItem>
                                                                            <MenuItem value='<'>is less than</MenuItem>
                                                                            <MenuItem value='>='>is greater than or equal to</MenuItem>
                                                                            <MenuItem value='<='>is less than or equal to</MenuItem>
                                                                            <MenuItem value='<>'>is not equal to</MenuItem>
                                                                            <MenuItem value='LIKE'>is like</MenuItem>
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                    <DataField id="ea1bce09-eb5d-4a4a-bc64-9828a9f016bd"
                                                                        label='Value'
                                                                        name='filterValue'
                                                                        required={false}
                                                                        value={filter.filterValue}
                                                                        onChange={(event) => handleUserDefinedFilterValueChange(event, filter.key)}
                                                                        error={dataLoaderFormData.tableName.isError}
                                                                        readOnly={(mode === constants.MODE.view) ? true : false}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={1}>
                                                                    <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => deleteUserDefinedFilter(filter.key)} >
                                                                        <DeleteSharpIcon />
                                                                    </IconButton>
                                                                </Grid>

                                                            </Grid>
                                                        </Box>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <h2>Triggers</h2>
                                            <p>Triggers for the task to commence.</p>

                                            <ul>
                                                {jobList && jobList.length > 0 && jobList?.map((job: any, index: number) => {
                                                    return <li key={index}>{cronstrue.toString(job.cronExpression)} (UTC {job.timezone})
                                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => setOpenTimeTrigger(true)} >
                                                            <DeleteSharpIcon />
                                                        </IconButton>
                                                        <>
                                                            <CustomizedDialogs
                                                                dialogHeight=''
                                                                modalSize="md"
                                                                key="trigger"
                                                                modalTitle="Delete Confirmation"
                                                                isOpen={openTimeTrigger}
                                                                onClose={handleClose}
                                                                footerAction={
                                                                    <Stack direction="row" spacing={2}>
                                                                        <Button id="c4c8c29c-9b5c-48c0-909c-6065cddedb90" color="primary" onClick={() => handleJobDelete(job.id)} autoFocus>
                                                                            Yes
                                                                        </Button>
                                                                        <Button id="e46bbf5f-7dd9-48a6-95e2-f77b48c50b38" color="primary" onClick={handleClose}>
                                                                            No
                                                                        </Button>
                                                                    </Stack>
                                                                }
                                                            >
                                                                <>Are you sure you want to delete time based trigger?</>
                                                            </CustomizedDialogs>
                                                        </>

                                                    </li>

                                                })}
                                                {eventList && eventList.length > 0 && eventList?.map((task: any, index: number) => {
                                                    return <li key={index}>
                                                        {
                                                            task.eventType === "LOAD_TASK.SUCCESS"
                                                                ? `Events: ${task.description ? task.description : 'No description'}`
                                                                : `Inbound Webhook: ${AppConfig().BaseUrl}api/v1/webhooks/${task.eventQualifier}?type=loader`
                                                        }
                                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => setOpen(true)}>
                                                            <DeleteSharpIcon />
                                                        </IconButton>
                                                        <>
                                                            <CustomizedDialogs
                                                                dialogHeight=''
                                                                modalSize="md"
                                                                key="target"
                                                                modalTitle="Delete Confirmation"
                                                                isOpen={open}
                                                                onClose={handleClose}
                                                                footerAction={
                                                                    <Stack direction="row" spacing={2}>
                                                                        <Button id="4c1661f4-5306-44a6-aaea-1ff9a7b573af" color="primary" onClick={() => handleExtractorDelete(task.id)} autoFocus>
                                                                            Yes
                                                                        </Button>
                                                                        <Button id="f17cdfa2-113e-44ad-85ca-f7a4dc58493c" color="primary" onClick={handleClose}>
                                                                            No
                                                                        </Button>
                                                                    </Stack>
                                                                }
                                                            >
                                                                <>Are you sure you want to delete the trigger?</>
                                                            </CustomizedDialogs>
                                                        </>

                                                    </li>
                                                })}
                                            </ul>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="flex-start" style={{ marginBottom: '1em' }}>
                                                <Button id="18f52239-0d11-4263-8e3a-cab9b90e2427" color="primary" variant="contained" onClick={addTrigger}>Add New </Button>
                                            </Box>
                                            <div>
                                                {triggers.map((trigger: any) => (
                                                    <React.Fragment key={trigger.key}>
                                                        {trigger.key != 0 ?
                                                            <Box sx={{ border: 1, borderColor: 'divider', padding: 2, width: '100%', display: 'block' }}>
                                                                <Grid container spacing={5} alignItems="center">
                                                                    <TriggerRow value={trigger} onChange={onTriggerChange} type={'loader'} />
                                                                    <p></p>
                                                                    <Grid item xs={1}>

                                                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => deleteTrigger(trigger.key)} >
                                                                            <DeleteSharpIcon />
                                                                        </IconButton>
                                                                    </Grid>

                                                                </Grid>
                                                            </Box>
                                                            : <></>}
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <h2>Actions</h2>
                                            <p>Actions to take once the task has successfully completed. </p>
                                            <h3>Outbound Webhooks <Tooltip title="Once the task runs successfully, a message will be sent via an API/webhook">
                                                <IconButton>

                                                    <InfoIcon />
                                                </IconButton>
                                            </Tooltip></h3>
                                            {outbound && outbound.length > 0 && outbound.map((task: any, index: number) => {
                                                return <li key={index}> Webhook: {task.eventActionValue ? task.eventActionValue : ''} {task.outboundWebhookHeader ? ` - ${task.outboundWebhookHeader}` : ''}
                                                    <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => setOpenOutbound(true)}>
                                                        <DeleteSharpIcon />
                                                    </IconButton>
                                                    <>
                                                        <CustomizedDialogs
                                                            dialogHeight=''
                                                            modalSize="md"
                                                            key="target"
                                                            modalTitle="Delete Confirmation"
                                                            isOpen={openOutbound}
                                                            onClose={handleClose}
                                                            footerAction={
                                                                <Stack direction="row" spacing={2}>
                                                                    <Button id="d18c8fcb-ca73-44df-a66f-d1652124a5c9" color="primary" onClick={() => handleOutboundDelete(task.id)} autoFocus>
                                                                        Yes
                                                                    </Button>
                                                                    <Button id="4cf02305-6439-4d09-b4e0-998abb7ee48a" color="primary" onClick={handleClose}>
                                                                        No
                                                                    </Button>
                                                                </Stack>
                                                            }
                                                        >
                                                            <>Are you sure you want to delete outbound webhook?</>
                                                        </CustomizedDialogs>
                                                    </>
                                                </li>
                                            })}
                                            {mode === constants.MODE.view ? '' :
                                                <>
                                                    <Box display="flex" justifyContent="flex-start" style={{ marginBottom: '1em' }}>
                                                        <Button id="c3fbdcb6-107b-4827-8563-d40f080cb151" color="primary" variant="contained" onClick={addAction}>
                                                            Add New </Button>
                                                    </Box>
                                                    <div>
                                                        {actions.map((actionItem) => (
                                                            <React.Fragment key={actionItem.key}>
                                                                <Box sx={{ border: 1, borderColor: 'divider', padding: 2, width: '100%', display: 'block' }}>
                                                                    <Grid container spacing={5} alignItems="center">
                                                                        <ActionRow value={actionItem} onChange={onActionChange} />
                                                                        <Grid item xs={1}>
                                                                            <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => deleteAction(actionItem.key)} >
                                                                                <DeleteSharpIcon />
                                                                            </IconButton>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Box>

                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                                </>
                                            }
                                        </Grid>
                                    </>

                                    : ""}

                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="flex-end" m={2} >
                                        {/* Edit Loader */}
                                        {mode === constants.MODE.edit && (
                                            <Button id="ed23ce06-854e-44ee-990a-96a5c4155250"
                                                color="primary"
                                                variant="contained"
                                                onClick={goBack}
                                                style={{ marginRight: "1em" }}
                                            >
                                                Cancel
                                            </Button>
                                        )}
                                        {mode === "Edit" ?
                                            <Box display="flex" justifyContent="flex-end">
                                                {pendingEditedLoader && loader || pending && loader ? <>
                                                    <LoadingButton
                                                        loading
                                                        variant="outlined"
                                                        size="small"
                                                        loadingPosition="start"
                                                        startIcon={<SaveIcon />}
                                                    >
                                                        Processing
                                                    </LoadingButton> </> :
                                                    <Button id="displaySaveBtn"
                                                        color="primary"
                                                        disabled={displaySaveBtn}
                                                        style={{ marginRight: "1em" }}
                                                        variant="contained"
                                                        onClick={createNewDataLoader}>
                                                        Save
                                                    </Button>
                                                }

                                            </Box> : ''
                                        }
                                        {mode !== constants.MODE.view && <Box display="flex" justifyContent="flex-end">
                                            <Button id="viewLoader"
                                                variant="contained"
                                                onClick={viewLoader}
                                            >
                                                View Loader
                                            </Button>
                                        </Box>
                                        }
                                    </Box>
                                </Grid>

                                {mode !== "Add" ? <>
                                    <Grid item xs={6}>
                                        <Box display="flex" justifyContent="flex-start">
                                            Last Updated By: {lastUpdated}
                                        </Box>
                                        <Box display="flex" justifyContent="flex-start">
                                            Last Modified On: {lastModified}
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box display="flex" justifyContent="flex-end">
                                            Created By: {createdBy}
                                        </Box>
                                        <Box display="flex" justifyContent="flex-end">
                                            Created On: {createdOn}
                                        </Box>
                                    </Grid>
                                </> : ''}
                                {mode === constants.MODE.view && isAdmin && getDataLoader?.businessMetadata.owner === userProfile.userPrincipalName && <> <Grid item xs={12}>
                                        <h2>Overrides</h2>
                                        <OverRideExplorer myOverrides={true} tableId={tableId} />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <Button id="0b6dbb79-8154-4335-b604-4e8bc2cc3a04" color="primary" variant="contained" onClick={renewOverridesLink} style={{ marginRight: '1em', marginTop: '1em' }}>
                                            Renew Overrides
                                        </Button>
                                    </Grid>
                                </>
                                }
                                {mode === constants.MODE.view && isAdmin && <Grid item xs={12}>
                                        <h2>Owner Overrides</h2>
                                        <OverRideExplorer tableId={tableId} grantee={grantee}/>
                                    </Grid>
                                }
                            </Grid>
                        }
                    </Form>
                </div>
            </Formik>
            <DataProvisioningWorkflow createNewDataLoader={createNewDataLoader} pending={pending} loader={loader} />
        </>
    );
}

export default DataLoaderForm;